import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Switch,
  Card,
  CardContent,
  Button,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Menu,
  Grid,
  Select,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Chip,
  FormGroup,
  Modal,
  Alert,
  alpha,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import axios from "axios";
import {
  showToast,
  WEBSERVICE,
  ADDR,
  deviceLogout,
  getExchangeFeaturesCurrency,
} from "../../CoreDataService";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";
import { QRCodeCanvas } from "qrcode.react";
import { useSelector } from "react-redux";
import { MenuItem, InputAdornment } from "@mui/material";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import {
  Row,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, Link } from "react-router-dom";
import { useOtp } from "../../Contexts/OtpContext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DataTable from "../../Common/DataTable";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import InfoPopUp from "../../Common/InfoPopUp";
import InfoIcon from "@mui/icons-material/Info";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// ...existing imports...

const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1,
    "& fieldset": {
      borderColor: "#ccc",
    },
    "&:hover fieldset": {
      borderColor: "#888",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#284ccf",
    },
  },
  "& .MuiFormHelperText-root": {
    mt: 0.5,
    mx: 0,
  },
  "& label": {
    color: "#284ccf",
    "&.Mui-focused": {
      color: "#284ccf",
    },
  },
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "2px solid #616266",
  padding: "16px",
};

const bodyStyle = {
  padding: "16px",
  textAlign: "left",
};

const Settings = () => {
  const { sendSmartMobileOtp } = useOtp();
  const [apiTypeList, setApiTypeList] = useState([]);
  const [isApiTypeLoaded, setIsApiTypeLoaded] = useState(false);
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);

  const contentStyle = {
    bgcolor: theme === "dark" ? "#273338" : "#fff",
    color: theme === "dark" ? "white" : "black",
    textAlign: "center",
    mx: "auto",
    my: "10vh",
    width: { xs: "90%", sm: 500 },
    borderRadius: 2,
    boxShadow: "0 0 60px 30px #fff,0 0 100px 60px #f0f,0 0 140px 90px #0ff",
    outline: "none",
  };

  useEffect(() => {
    // Fetch API types for permissions
    const uuid = localStorage.getItem("uuid");
    fetch(`https://accounts.paybito.com/api/user/allApiType?uuid=${uuid || ""}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.apiTypeList) {
          setApiTypeList(data.apiTypeList);
        }
        setIsApiTypeLoaded(true);
      })
      .catch(() => {
        setApiTypeList([]);
        setIsApiTypeLoaded(true);
      });
  }, []);

  const isPermissionEnabled = (permKey) => {
    if (!isApiTypeLoaded) {
      return true; // fallback to show all while loading or if it fails
    }
    const normalizedKey = permKey.toLowerCase();
    return apiTypeList.some((type) => {
      const typeName = type.apiTypeName.toLowerCase();
      if (typeName === normalizedKey) return true;
      if (normalizedKey === "spot" || normalizedKey === "isspottrade") {
        return typeName === "spot trade" || typeName === "spot";
      }
      if (normalizedKey === "futures" || normalizedKey === "isfuturestrade") {
        return typeName === "futures trade" || typeName === "futures";
      }
      if (normalizedKey === "options" || normalizedKey === "isoptionstrade") {
        return typeName === "options trade" || typeName === "options";
      }
      if (normalizedKey === "copytrading" || normalizedKey === "iscopytrading") {
        return typeName === "copy trading" || typeName === "copy trade";
      }
      if (normalizedKey === "assetmanagement" || normalizedKey === "isassetmanagement") {
        return typeName === "asset management";
      }
      if (normalizedKey === "web3wallet" || normalizedKey === "isweb3wallet") {
        return typeName === "web3 wallet";
      }
      const cleanKey = normalizedKey.replace(/^is/, "");
      return typeName === cleanKey || typeName.replace(/\s+/g, "") === cleanKey;
    });
  };
  const navigate = useNavigate();

  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [txnCurrencyId, setTxnCurrencyId] = useState(null);
  const [identificationStatus, setIdentificationStatus] = useState("");
  const [bankDetailStatus, setBankDetailStatus] = useState("");
  const [twofaModalOpen, setTwofaModalOpen] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [emailOtpPrivacy, setEmailOtpPrivacy] = useState("");
  const [twoFactorOtp, setTwoFactorOtp] = useState("");
  const [twoFactorOtpPrivacy, setTwoFactorOtpPrivacy] = useState("");
  const [specificModalStatus, setSpecificModalStatus] = useState("pre");
  const [exist2FaKey, setExist2FaKey] = useState("0");
  const [isGetCodeButtonDisabled, setIsGetCodeButtonDisabled] = useState(false);
  const [messageOtpSpecific, setMessageOtpSpecific] = useState("");
  const [messagePhoneOtpSpecific, setMessagePhoneOtpSpecific] = useState("");

  const [googleAuthModalOpen, setGoogleAuthModalOpen] = useState(false);
  const [twoFactorAuthKey, setTwoFactorAuthKey] = useState(
    "otpauth://totp/example?secret=123456ABC&issuer=MyApp"
  );
  const [twoFactorSecureToken, setTwoFactorSecureToken] = useState(
    "ABCD-1234-EFGH-5678"
  );
  const [otpTwoFaQrModalOpen, setOtpTwoFaQrModalOpen] = useState(false);
  const [googleAuthOtp, setGoogleAuthOtp] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [countdownPhone, setCountdownPhone] = useState(0);
  const [radio, setRadio] = useState(
    txnCurrencyId == localStorage.getItem("tradingFeesCurrencyId")
      ? "on"
      : "off"
  );

  const [lockOutgoingTransactionStatus, setLockOutgoingTransactionStatus] =
    useState(null);
  const [twoFactorStatus, setTwoFactorStatus] = useState();
  const [
    facebookLoginEnableDisableStatus,
    setFacebookLoginEnableDisableStatus,
  ] = useState(null);
  const [phoneAuthStatus, setPhoneAuthStatus] = useState(
    localStorage.getItem("userSmsAuthStatus")
  );

  const [incomingTransactionAlert, setIncomingTransactionAlert] =
    useState(null);
  const [pinLock, setPinLock] = useState(null);
  const [soundAlert, setSoundAlert] = useState(null);
  const [alertRate, setAlertRate] = useState(null);
  const [rateAlert, setRateAlert] = useState(null);
  const [vibrateAlert, setVibrateAlert] = useState(null);
  const [phoneChangeFirstModal, setPhoneChangeFirstModal] = useState(false);
  const [isPrivacyChecked, setIsPrivacyChecked] = useState(false);
  const [privaacyModalOpen, setPrivaacyModalOpen] = useState(false);
  const [isIPEnable, setIPEnable] = useState(false);
  const [settingFeature, setSettingFeature] = useState({});
  const {
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm();

  console.log("twoFactorAuthKey", twoFactorAuthKey);

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCountries, setFilterCountry] = useState([]);
  const [formData, setFormData] = useState();
  const [showCaptchaModal, setShowCaptchModal] = useState(false);
  const handlecloseCaptcha = () => setShowCaptchModal(false);
  const [showPhoneDisclaimer, setShowPhoneDisclaimer] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const brokerIdRef = useRef(null);
  const [countryFlag, setCountryFlag] = useState([]);

  const [smsOtpForRegisteredNo, setSmsOtpForRegisteredNo] = useState("");
  const [smsOtpForNewNo, setSmsOtpForNewNo] = useState("");
  const [registeredPhone, setRegisteredPhone] = useState(
    localStorage.getItem("phone")
  );
  const [selectedCountryPhone, setSelectedCountryPhone] = useState("");
  const [editablePhone, setEditablePhone] = useState("");
  const [isPrevMobileOtpSent, setIsPrevMobileOtpSent] = useState(false);
  const [phoneAuthStatusFromUiEnd, setPhoneAuthStatusFromUiEnd] = useState(
    localStorage.getItem("userSmsAuthStatus")
  );
  const [tradingFeesCurrency, setTradingFeesCurrency] = useState(
    localStorage.getItem("tradingFeesCurrency")
  );
  const [googleAuthModalPassChangeOpen, setGoogleAuthModalPassChangeOpen] =
    useState(false);
  const [twoFactorOtpPassChange, setTwoFactorOtpPassChange] = useState("");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [selectedCountry, setSelectedCountry] = useState("");
  const [cryptoList, setCryptoList] = useState([]);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [deleteDataConfirmModal, setDeleteDataConfirmModal] = useState(false);
  const [deleteDataModal, setDeleteDataModal] = useState(false);

  const [apiKeys, setApiKeys] = useState([]);

  const [newKeyLabel, setNewKeyLabel] = useState("");
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedApi, setSelectedApi] = useState(null);
  const [ipList, setIpList] = useState([]);
  const [apiName, setApiName] = useState("");
  const [ipRestriction, setIpRestriction] = useState("unrestricted");
  const [emailOtpApiModify, setEmailOtpApiModify] = useState("");
  const [twoFactorOtpGaApiKey, setTwoFactorOtpGaApiKey] = useState("");
  const [twoFactorOtpPhoneApiKey, setTwoFactorOtpPhoneApiKey] = useState("");
  const [twofaModalApiKeyOpen, setTwofaModalApiKeyOpen] = useState(false);
  const [isGetCodePhoneButtonDisabled, setIsGetCodePhoneButtonDisabled] =
    useState(false);
  const [permissions, setPermissions] = useState({});
  const [apiModifyStatus, setApiModifyStatus] = useState("");
  const [deleteapikeyObj, setDeleteApiPayload] = useState({});
  const { userInfo } = useSelector((state) => state);

  const [newApiCreateName, setNewApiCreateName] = useState("");
  const [userLoggedindevices, setUserLoggedindevices] = useState([]);

  const [logoutModalShow, setLogoutModalShow] = useState(false);
  const [isWhitelistEnabled, setIsWhitelistEnabled] = useState(1);
  const [openAddressManagementConfModal, setOpenAddressManagementConfModal] =
    useState(false);
  const [addrMgmtTitle, setAddrMgmtTitle] = useState("");
  const [addrMgmtDescription, setAddrMgmtDescription] = useState("");
  const [addrMgmtConfirmText, setAddrMgmtConfirmText] = useState("");

  const [twofaModalAddressWhiteListOpen, setTwofaModalAddressWhiteListOpen] =
    useState(false);

  const [emailOtpAddr, setEmailOtpAddrOtp] = useState("");
  const [twoFactorAddrOtp, setTwoFactorAddrOtp] = useState("");
  const [isAddrEnable, setIsAddrEnable] = useState(false);

  const [phoneAuthModalChangeOpen, setPhoneAuthModalChangeOpen] =
    useState(false);
  const [twoFactorPhoneGaChange, setTwoFactorPhoneGaChange] = useState("");

  const [newlyCreatedApiKeyName, setNewlyCreatedApiKeyName] = useState("");
  const [newlyCreatedApiKeySecretKey, setNewlyCreatedApiKeySecretKey] =
    useState("");
  const [newlyCreatedApiKeyPublicKey, setNewlyCreatedApiKeyPublicKey] =
    useState("");
  const [deleteAllApiModal, setDeleteAllApiModal] = useState("");
  const [isSocialEnable, setIsSocialEnable] = useState("");
  const [socialAuthModalOpen, setSocialAuthModalOpen] = useState(false);
  const [emailOtpSocial, setEmailOtpSocial] = useState("");
  const [twoFactorSocialOtp, setTwoFactorSocialOtp] = useState("");

  const [permissionsNew, setPermissionsNew] = React.useState({
    read: true,
    deposit: false,
    withdraw: false,
    spot: false,
    futures: false,
    options: false,
    bank: false,
  });
  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);
  const [brokerID, setBrokerID] = useState("");

  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const autoSubmittedRef = useRef(false);
  const [brokerSocialLogin, setBrokerSocialLogin] = useState(false);

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // State for validation
  const [touched, setTouched] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [errorss, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isMatched, setIsMatched] = useState(false);
  const [showPasswordHint, setShowPasswordHint] = useState(false);

  // Password regex pattern
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@.!])[a-zA-Z\d$@.!]{8,35}$/;

  // Update validation when values change
  useEffect(() => {
    validatePasswords();
  }, [newPassword, confirmPassword, oldPassword]);

  const validatePasswords = () => {
    const newErrors = { ...errorss };

    // Validate old password (only if touched)
    if (touched.oldPassword) {
      if (!oldPassword.trim()) {
        newErrors.oldPassword = "Old password is required";
      } else {
        newErrors.oldPassword = "";
      }
    }

    // Validate new password (only if touched)
    if (touched.newPassword) {
      if (!newPassword.trim()) {
        newErrors.newPassword = "New password is required";
        setShowPasswordHint(false);
      } else if (!passwordRegex.test(newPassword)) {
        newErrors.newPassword = "Password does not meet requirements";
        setShowPasswordHint(true);
      } else {
        newErrors.newPassword = "";
        setShowPasswordHint(false);
        setIsPasswordValid(true);
      }
    }

    // Validate confirm password (only if touched)
    if (touched.confirmPassword) {
      if (!confirmPassword.trim()) {
        newErrors.confirmPassword = "Please confirm your password";
        setIsMatched(false);
      } else if (confirmPassword !== newPassword) {
        newErrors.confirmPassword = "Passwords do not match";
        setIsMatched(false);
      } else {
        newErrors.confirmPassword = "";
        setIsMatched(true);
      }
    }

    // Check if passwords match (even if confirmPassword not touched yet)
    if (newPassword && confirmPassword) {
      if (confirmPassword !== newPassword) {
        setIsMatched(false);
      } else {
        setIsMatched(true);
      }
    }

    setErrors(newErrors);
  };

  const handleOldPasswordChange = (e) => {
    const value = e.target.value;
    setOldPassword(value);

    // Mark as touched
    if (!touched.oldPassword) {
      setTouched((prev) => ({ ...prev, oldPassword: true }));
    }

    // Validate if touched
    if (touched.oldPassword || value) {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          oldPassword: "Old password is required",
        }));
      } else {
        setErrors((prev) => ({ ...prev, oldPassword: "" }));
      }
    }
  };

  const handleOldPasswordBlur = () => {
    if (!touched.oldPassword) {
      setTouched((prev) => ({ ...prev, oldPassword: true }));
    }
    validatePasswords();
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);

    // Mark as touched
    if (!touched.newPassword) {
      setTouched((prev) => ({ ...prev, newPassword: true }));
    }

    // Validate if touched or there's content
    if (touched.newPassword || value) {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          newPassword: "New password is required",
        }));
        setShowPasswordHint(false);
      } else if (!passwordRegex.test(value)) {
        setErrors((prev) => ({
          ...prev,
          newPassword: "Password does not meet requirements",
        }));
        setShowPasswordHint(true);
      } else {
        setErrors((prev) => ({ ...prev, newPassword: "" }));
        setShowPasswordHint(false);
        setIsPasswordValid(true);
      }
    }

    // Re-check match when new password changes
    if (confirmPassword && value !== confirmPassword) {
      if (touched.confirmPassword) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match",
        }));
      }
      setIsMatched(false);
    } else if (confirmPassword && value === confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: "" }));
      setIsMatched(true);
    }
  };

  const handleNewPasswordBlur = () => {
    if (!touched.newPassword) {
      setTouched((prev) => ({ ...prev, newPassword: true }));
    }
    validatePasswords();
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    // Mark as touched
    if (!touched.confirmPassword) {
      setTouched((prev) => ({ ...prev, confirmPassword: true }));
    }

    // Validate if touched or there's content
    if (touched.confirmPassword || value) {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Please confirm your password",
        }));
        setIsMatched(false);
      } else if (value !== newPassword) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match",
        }));
        setIsMatched(false);
      } else {
        setErrors((prev) => ({ ...prev, confirmPassword: "" }));
        setIsMatched(true);
      }
    }
  };

  const handleConfirmPasswordBlur = () => {
    if (!touched.confirmPassword) {
      setTouched((prev) => ({ ...prev, confirmPassword: true }));
    }
    validatePasswords();
  };

  const shouldShowMatchedMessage =
    newPassword &&
    confirmPassword &&
    isMatched &&
    !errors.confirmPassword &&
    (!touched.confirmPassword || !errors.confirmPassword);

  const checkPassword = () => {
    // Mark all fields as touched on submit
    const allTouched = {
      oldPassword: true,
      newPassword: true,
      confirmPassword: true,
    };
    setTouched(allTouched);

    // Validate all fields
    const newErrors = { ...errorss };

    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(newPassword)) {
      newErrors.newPassword = "Password does not meet requirements";
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);

    // Check if all fields are valid
    const isValid =
      oldPassword.trim() &&
      newPassword.trim() &&
      passwordRegex.test(newPassword) &&
      confirmPassword.trim() &&
      confirmPassword === newPassword;

    if (isValid) {
      console.log("Password change submitted:", {
        oldPassword,
        newPassword,
        confirmPassword,
      });

      if (twoFactorStatus != 0 || twoFactorStatus != "0") {
        setGoogleAuthModalPassChangeOpen(true);
      } else {
        showToast(
          "info",
          "Please turn on 2 Factor Authentication before changing password"
        );
      }
      // Add your API call or further processing here
    } else {
      console.log("Validation failed");
    }
  };

  useEffect(() => {
    autoSubmittedRef.current = false;
  }, [twofaModalOpen]);

  useEffect(() => {
    if (brokerDetailedInfo.socialLogin == 1) {
      setBrokerSocialLogin(true);
    } else {
      setBrokerSocialLogin(false);
    }
  }, [brokerDetailedInfo]);

  useEffect(() => {
    if (
      emailOtp?.length === 8 &&
      twoFactorOtp?.length === 6 &&
      specificModalStatus === "post" &&
      (exist2FaKey === 1 || exist2FaKey === "1")
    ) {
      updateUserAppSettings();
      setTwofaModalOpen(false);
    }
  }, [emailOtp, twoFactorOtp]);
  useEffect(() => {
    if (emailOtp?.length === 8) {
      if (
        exist2FaKey === "1" ||
        exist2FaKey === 1 ||
        specificModalStatus === "post"
      ) {
        if (twoFactorOtp?.length === 6) {
          handleOtpPopupSubmitfor2FactorAuth();
        }
      } else {
        handleOtpPopupSubmitfor2FactorAuth();
      }
    }
  }, [emailOtp, twoFactorOtp]);

  useEffect(() => {
    if (
      emailOtp?.length === 8 &&
      twoFactorOtp?.length === 6 &&
      specificModalStatus === "post" &&
      (exist2FaKey === 1 || exist2FaKey === "1")
    ) {
      handleOtpPopupSubmitfor2FactorAuth();
    }
  }, [emailOtp, twoFactorOtp]);

  useEffect(() => {
    if (emailOtpSocial?.length === 8 && twoFactorSocialOtp?.length === 6) {
      enableDisableSocialAuth();
    }
  }, [emailOtpSocial, twoFactorSocialOtp]);

  const handleCloseInfoModal = () => setInfoModal(false);

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };

  useEffect(() => {
    if (smsOtpForNewNo?.length === 8 && smsOtpForRegisteredNo?.length === 8) {
      confirmOtpCallbackForVerifyingNewMobile();
    }
  }, [smsOtpForNewNo, smsOtpForRegisteredNo]);
  useEffect(() => {
    if (emailOtpApiModify?.length === 8 && twoFactorOtpGaApiKey?.length === 6) {
      handleOtpPopupSubmitfor2FactorAuthApiModify();
    }
  }, [emailOtpApiModify, twoFactorOtpGaApiKey]);

  const handleCloseTwofaModal = () => {
    setTwofaModalApiKeyOpen(false);
    setCountdown(0);
    setEmailOtpApiModify("");
    setTwoFactorOtpGaApiKey("");
    setIsGetCodeButtonDisabled(false);
  };
  const { control, register, setValue, getValues, watch } = useForm({
    // defaultValues: {
    //   alerts: [{ crypto: "", direction: "Up", percentage: 5 }],
    // },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "alerts",
  });

  useEffect(() => {
    setIsPrivacyChecked(userInfo?.userResult?.privacyOn === 1);
  }, [userInfo]);

  useEffect(() => {
    if (txnCurrencyId) {
      setRadio(
        txnCurrencyId == localStorage.getItem("tradingFeesCurrencyId")
          ? "on"
          : "off"
      );
    }
  }, [txnCurrencyId]);

  useEffect(() => {
    if (googleAuthOtp?.length === 6) {
      sendGoogleAuthOtp();
    }
  }, [googleAuthOtp]);

  const fetchCryptoAlerts = async () => {
    try {
      const payload = { uuid: localStorage.getItem("uuid") };
      const response = await axios.post(
        `${WEBSERVICE}user/getCryptoAlertByUser`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        const alerts = response.data.alerts.reverse();

        if (alerts.length === 0) {
          // If no alerts, add an empty row to show the form
          append({ crypto: "", direction: "Up", percentage: 5, isNew: true });
        } else {
          const formattedAlerts = alerts.map((alert, index) => ({
            id: index + 1,
            crypto: alert.currency,
            direction: alert.direction,
            percentage: alert.roc,
            isNew: false, // to track if it's from API
          }));
          replace(formattedAlerts); // use replace to load them all into form

          console.log("formattedAlerts", formattedAlerts);
        }
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error fetching crypto alerts:", error);
    }
  };

  const fetchCryptoList = async () => {
    try {
      const response = await axios.get(`${WEBSERVICE}home/getAllAlertCryptos`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      });
      if (response.data.error.error_data === 0) {
        setCryptoList(response.data.currencyList);
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error fetching crypto list:", error);
    }
  };

  const renderAllCryptoAlertList = () => {
    const payload = { uuid: localStorage.getItem("uuid") };

    axios
      .post(`${WEBSERVICE}user/getCryptoAlertByUser`, JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const data = response.data;

        console.log("API Response:", data);
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  const saveAlert = async (index) => {
    const alert = getValues(`alerts.${index}`);

    // console.log('alerts',alert,index);

    if (!alert.crypto) {
      showToast("error", "Please select a crypto");
      return;
    }

    const payload = {
      uuid: localStorage.getItem("uuid"),
      currency: alert.crypto,
      roc: alert.percentage,
      direction: alert.direction,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/createCryptoAlert`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", "Alert saved successfully!");
        const updatedAlerts = getValues("alerts").map((item, idx) =>
          idx === index ? { ...item, isNew: false } : item
        );

        replace(updatedAlerts); // Use useFieldArray's replace to update state
        renderAllCryptoAlertList();
        fetchCryptoList();
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error saving alert:", error);
    }
  };

  const validatePercentage = (value, index) => {
    let reg = /^(?:[1-9]\d{0,4}|0)(?:\.\d{1,2})?$/gm;
    if (!value.match(reg) || parseFloat(value) <= 0) {
      showToast("error", "Please provide a valid percentage");
      setValue(`alerts.${index}.percentage`, "");
      return "";
    }
    return value;
  };

  const getCodeFromEmail = async (param) => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ResendOTP/${param}`,
        { email: localStorage.getItem("email") },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", "OTP Sent Successfully to Registered Email Id");
        setMessageOtpSpecific(
          `Enter the 8-digit code received by ${localStorage.getItem("email")}`
        );
        startCountdown(300);
      }
    } catch (error) {
      showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
    }
  };

  const startCountdown = (duration) => {
    setIsGetCodeButtonDisabled(true);
    setCountdown(duration);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsGetCodeButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const getCodeFromPhoneSms = async (param) => {
    // console.log('userInfo',userInfo);

    let payload = {
      phone: userInfo.userResult.phone,
      countryCode: userInfo.userResult.countryCode,
    };
    try {
      await sendSmartMobileOtp(payload, param);
      setMessagePhoneOtpSpecific(`Input OTP sent to your existing phone no`);
      startCountdownPhone(300);
    } catch (error) {
      console.error("Settings API Key OTP Error:", error);
    }
  };

  const startCountdownPhone = (duration) => {
    setIsGetCodePhoneButtonDisabled(true);
    setCountdownPhone(duration);
    const timerPhone = setInterval(() => {
      setCountdownPhone((prev) => {
        if (prev <= 1) {
          clearInterval(timerPhone);
          setIsGetCodePhoneButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const changeStatusFor2FactorAuth = (content) => {
    // setTwoFactorStatus((prevStatus) => (prevStatus === "0" ? "1" : "0"));
    setEmailOtp("");
    setTwoFactorOtp("");

    console.log("infffff");

    if (twoFactorStatus === "0" || twoFactorStatus === 0) {
      // setTwoFactorStatus(1)
      // setTwofaModalOpen(true);
      handleOtpPopupfor2FactorAuth("pre");
    } else {
      // setTwoFactorStatus(0)

      // setTwoFactorStatus("0");
      // setTwofaModalOpen(true);
      handleOtpPopupfor2FactorAuth("post");
    }
  };

  const handleOtpPopupfor2FactorAuth = (flag) => {
    setExist2FaKey(localStorage.getItem("exist2FaKey"));

    // Using a function inside setState to ensure the update is completed
    setSpecificModalStatus(() => {
      console.log("Setting specificModalStatus:", flag);
      return flag;
    });

    // Use a short timeout to wait for state update before opening the modal
    setTimeout(() => {
      console.log("twoFactorStatus:", exist2FaKey);
      console.log("specificModalStatus:", flag);
      setTwofaModalOpen(true);
      getCodeFromEmail("2fa");
    }, 0); // Ensures modal opens **after** state updates
  };

  const copySecureCode = () => {
    navigator.clipboard.writeText(twoFactorSecureToken);
    showToast("success", "Recovery key copied to clipboard!");
  };

  const googleTwoFactorAuth = async (content) => {
    try {
      const inputObj = {
        userId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
        otp: emailOtp,
      };

      if (exist2FaKey === "1" || exist2FaKey === 1) {
        inputObj["securityCode"] = twoFactorOtp;
      }

      const response = await axios.post(
        `${WEBSERVICE}user/GetTwoFactorykey`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        setTwoFactorSecureToken(result.userResult.twoFactorAuthKey);

        const email = localStorage.getItem("email");
        const secret = result.userResult.twoFactorAuthKey;
        const issuer = brokerBasicInfo.exchange;

        // The + sign needs to be encoded as %2B
        const label = encodeURIComponent(email);
        const encodedIssuer = encodeURIComponent(issuer);

        const otpAuthUrl = `otpauth://totp/${label}?secret=${secret}&issuer=${encodedIssuer}`;
        setTwoFactorAuthKey(otpAuthUrl);
        // setTwoFactorAuthKey(
        //   `otpauth://totp/${localStorage.getItem("email")}?secret=${
        //     result.userResult.twoFactorAuthKey
        //   }&issuer=${brokerBasicInfo.exchange}`
        // );
        setGoogleAuthModalOpen(true);
      }
    } catch (error) {
      showToast("error", "Could Not Connect To Server");
    }
  };

  console.log("twoFactorAuthKey", twoFactorAuthKey);

  // const changeStatusFor2FactorAuth = () => {
  //     // alert('hhshsh')
  //     setTwoFactorStatus((prevStatus) => !prevStatus);
  //     // You can add an API call here to update the status in the backend
  // };

  const handleOtpPopupSubmitfor2FactorAuth = () => {
    setTwofaModalOpen(false);

    if (specificModalStatus === "pre") {
      googleTwoFactorAuth();
      console.log("Submitting OTP for enabling 2FA");
    } else {
      // console.log("Updating user app settings");
    }
  };

  const updateUserAppSettings = async () => {
    try {
      const updateSettingObj = {
        userId: localStorage.getItem("user_id"),
        lock_outgoing_transactions: lockOutgoingTransactionStatus,
        two_factor_auth: twoFactorStatus === "0" ? "1" : "0",
        rate_alert: rateAlert,
        vibrate_alert: vibrateAlert,
        incoming_transactions_alert: incomingTransactionAlert,
        pin_lock: pinLock,
        sound_alert: soundAlert,
        alert_rate: alertRate,
        uuid: localStorage.getItem("uuid"),
      };

      if (exist2FaKey === 1 || exist2FaKey === "1" || twoFactorOtp) {
        updateSettingObj["otp"] = emailOtp;
        updateSettingObj["securityCode"] = twoFactorOtp;
      }

      console.log("twoFactorOtp", twoFactorOtp);

      const response = await axios.post(
        `${WEBSERVICE}user/SaveUserAppSettings`,
        updateSettingObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast(
          "success",
          `Two-factor verification turned ${twoFactorStatus == "1" || twoFactorStatus == 1 ? "off" : "on"
          }. Login Again.`
        );
        setTimeout(() => {
          deviceLogout("userLogout", navigate);
        }, 400);
      }
    } catch (error) {
      showToast("error", "Could Not Connect To Server");
    }
  };

  const updateUserAppSettings1 = async (two_factor_auth) => {
    console.log("calling1", two_factor_auth);

    try {
      const updateSettingObj = {
        userId: localStorage.getItem("user_id"),
        lock_outgoing_transactions: lockOutgoingTransactionStatus,
        two_factor_auth: two_factor_auth,
        rate_alert: rateAlert,
        vibrate_alert: vibrateAlert,
        incoming_transactions_alert: incomingTransactionAlert,
        pin_lock: pinLock,
        sound_alert: soundAlert,
        alert_rate: alertRate,
        uuid: localStorage.getItem("uuid"),
        securityCode: googleAuthOtp,
      };

      if (
        (exist2FaKey === "1" || exist2FaKey === 1) &&
        (twoFactorStatus === "0" || twoFactorStatus === 0)
      ) {
        updateSettingObj["otp"] = emailOtp;
      }

      console.log("updateSettingObj", updateSettingObj);

      const response = await axios.post(
        `${WEBSERVICE}user/SaveUserAppSettings`,
        updateSettingObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        getUserAppSetting();

        console.log("twoFactorStatus", twoFactorStatus);

        if (twoFactorStatus === 0 || twoFactorStatus === "0") {
          showToast(
            "success",
            "Two-factor verification turned on. Login Again"
          );
        } else {
          showToast(
            "success",
            "Two-factor verification turned off. Login Again"
          );
          console.log("userLogout");
        }
        setTimeout(() => {
          deviceLogout("userLogout", navigate);
        }, 400);
      }
    } catch (error) {
      showToast("error", "Could Not Connect To Server");
    }
  };

  const sendGoogleAuthOtp = async () => {
    setEmailOtp("");
    setTwoFactorOtp("");

    console.log("calling");

    if (googleAuthOtp) {
      setTwoFactorStatus("1");
      await updateUserAppSettings1(1);
    } else {
      showToast("error", "Please Enter OTP");
    }
  };

  useEffect(() => {
    getCountryFlag();
    getUserAppSetting();
    fetchCryptoList();
    getApiKeyList();
    getUsersAllLoggedInDevices();
    getEnableDisableStatus();
    exchangeFeaturesCurrency();
    fetchCryptoAlerts();
    getBrokerExchangeFeatures();
  }, []);

  const exchangeFeaturesCurrency = async () => {
    const res = await getExchangeFeaturesCurrency();
    setTradingFeesCurrency(res?.tradingFeesCurrency);
  };

  const getBrokerExchangeFeatures = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    setBrokerID(brokerId);
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getBrokerExchangeFeatures/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      console.log("response setting", response);
      setSettingFeature(response?.data?.features);
    } catch (error) {
      console.error("Error fetching API keys", error);
    }
  };
  const getApiKeyList = async () => {
    try {
      const apikeylistObj = {
        userId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };
      const response = await axios.post(
        `${WEBSERVICE}user/getUserWiseApiKeyDetails`,
        JSON.stringify(apikeylistObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const result = response.data.apiKeyDetailsList;
      const sortedApiKeys = [...result].sort(
        (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
      );
      setApiKeys(sortedApiKeys || []);
    } catch (error) {
      console.error("Error fetching API keys", error);
    }
  };

  const handleAddIp = (event) => {
    if (event.key === "Enter" && event.target.value) {
      setIpList([...ipList, event.target.value]);
      setIPEnable(true);
      event.target.value = "";
    }
  };

  const handleDeleteIp = (ipToDelete) => {
    setIpList(ipList.filter((ip) => ip !== ipToDelete));
  };

  const getCountryFlag = async () => {
    const response = await axios.get(
      `${ADDR}/getExchangeCountries/${brokerBasicInfo.brokerId}`
    );

    const sortCountry = response?.data?.countries
      ?.sort((a, b) =>
        a.country.toLowerCase().localeCompare(b.country.toLowerCase())
      )
      ?.map((country) => ({
        value: country.dialCode,
        country: country.country,
        label: `(+${country.dialCode}) ${country.country}`,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
        code: country.code.toLowerCase(),
      }));
    setCountryFlag(sortCountry);
    setFilterCountry(sortCountry);
    setSelectedCountry(sortCountry[0]);
  };

  const validatePhoneNumber = async (phone) => {
    if (selectedCountry) {
      if (phone) {
        const data = {
          countryCode: selectedCountry?.value,
          phone: phone,
        };
        const response = await axios.post(`${WEBSERVICE}user/CheckPhone`, data);
        if (response?.data?.error?.error_data === 1) {
          showToast("error", response?.data?.error?.error_msg);
        } else {
          if (response?.data?.userResult.checkEmailPhoneFlag === 1) {
            showToast(
              "error",
              "Phone No. already registered , please try with another phone no."
            );
          }
        }
      } else {
        showToast("warning", "Please Provide Phone No");
      }
    } else {
      showToast("error", "Please select phone country code");
    }
  };

  const getUserAppSetting = async () => {
    try {
      console.log("Loading...");
      const settingObj = {
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        WEBSERVICE + "/user/GetUserAppSettings",
        settingObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
        return;
      }

      setTxnCurrencyId(result.userAppSettingsResult.txnCurrencyId);
      localStorage.setItem(
        "txncurrencyId",
        result.userAppSettingsResult.txnCurrencyId
      );
      setLockOutgoingTransactionStatus(
        result.userAppSettingsResult.lock_outgoing_transactions
      );
      setTwoFactorStatus(result.userAppSettingsResult.two_factor_auth);
      setFacebookLoginEnableDisableStatus(
        result.userAppSettingsResult.facebookAuthStatus
      );
      setPhoneAuthStatus(localStorage.getItem("userSmsAuthStatus"));
      setIncomingTransactionAlert(
        result.userAppSettingsResult.incoming_transactions_alert
      );
      setPinLock(result.userAppSettingsResult.pin_lock);
      setSoundAlert(result.userAppSettingsResult.sound_alert);
      setAlertRate(result.userAppSettingsResult.alert_rate);
      setRateAlert(result.userAppSettingsResult.rate_alert);
      setVibrateAlert(result.userAppSettingsResult.vibrate_alert);

      // Set identification status
      const docStatus = result.userAppSettingsResult.user_docs_status;
      if (docStatus === "") {
        setIdentificationStatus(
          "Identity verification documents not submitted."
        );
      } else if (docStatus === "1") {
        setIdentificationStatus("Identity verification documents verified.");
      } else if (docStatus === "0") {
        setIdentificationStatus(
          "Identity verification documents submitted for verification."
        );
      } else if (docStatus === "2") {
        setIdentificationStatus(
          "Identity verification documents declined, please submit again."
        );
      }

      // Set bank details status
      const bankStatus = result.userAppSettingsResult.bank_details_status;
      if (bankStatus === "") {
        setBankDetailStatus("Bank details not submitted.");
      } else if (bankStatus === "0") {
        setBankDetailStatus("Bank details submitted for verification.");
      } else if (bankStatus === "2") {
        setBankDetailStatus("Bank details verified.");
      } else if (bankStatus === "3") {
        setBankDetailStatus("Bank details declined, please submit again.");
      }
    } catch (error) {
      console.error("Error fetching settings", error);
      showToast("error", "Could Not Connect To Server");
    }
  };

  const handleSendOtpInSmsParent = async () => {
    const formValues = watch();

    setSelectedCountryPhone(formValues.phone);
    setEditablePhone(phone);

    console.log("phone", phone);
    console.log("country code", selectedCountry?.value);

    let flag = "changephone";
    let payload = {
      phone: phone,
      countryCode: selectedCountry?.value,
      uuid: localStorage.getItem("uuid"),
    };

    try {
      await sendSmartMobileOtp(payload, flag);
      startCountdownPhone(300);
      setIsPrevMobileOtpSent(true);
    } catch (error) {
      console.error("Settings Phone OTP Error:", error);
    }
  };

  const confirmOtpCallbackForVerifyingNewMobile = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
      phoneOtp: smsOtpForRegisteredNo,
      newPhoneOtp: smsOtpForNewNo,
      phone: Number(editablePhone),
      countryCode: selectedCountry?.value,
    };

    console.log("shhshhhs", payload);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ChangePhoneNo`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg); // Replace with a toast/snackbar if needed
      } else {
        showToast("success", "Phone number updated successfully");
        setPhoneChangeFirstModal(false);
      }
    } catch (error) {
      console.error("Error updating phone number:", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleStatusForPhoneAuth = () => {
    if (
      localStorage.getItem("userSmsAuthStatus") == "1" ||
      localStorage.getItem("userSmsAuthStatus") == 1
    ) {
      setPhoneAuthModalChangeOpen(true);
      // turning off the auth with otp modal open

      // changeStatusForPhoneAuth("off");
    } else {
      // turning on the auth api call

      changeStatusForPhoneAuth("on");
    }
  };

  const changeStatusForPhoneAuth = async (type) => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
      phoneValidation: type === "on" ? 1 : 0,
    };

    if (type !== "on") {
      payload.securityCode = twoFactorPhoneGaChange;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/updatePhoneValidation`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg); // Replace with a toast/snackbar if needed
        setPhoneAuthStatusFromUiEnd(localStorage.getItem("userSmsAuthStatus"));
        setTwoFactorPhoneGaChange("");
      } else {
        showToast(
          "success",
          `Phone number authentication has been turned ${type}, please login to continue`
        );
        setTwoFactorPhoneGaChange("");

        setPhoneAuthStatusFromUiEnd(type === "on" ? "1" : "0");

        setTimeout(() => {
          //   modalService.dismissAll(); // Dismiss modal (if applicable)
          //   //logout // Logout user
          // location.reload();
          deviceLogout("logoutFromAllDevices", navigate);
        }, 1500);
      }
    } catch (error) {
      console.error("Error updating phone validation status:", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  console.log(
    "radiosss",
    radio,
    txnCurrencyId,
    localStorage.getItem("tradingFeesCurrencyId")
  );

  const handleCheck = async (value) => {
    const uuid = localStorage.getItem("uuid");
    const currencyId =
      value === "on" ? localStorage.getItem("tradingFeesCurrencyId") : "0";
    const accessToken = localStorage.getItem("access_token");

    const inputObj = {
      uuid,
      currencyId,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/changeTransactionChargeCurrency`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data.error.error_data === 1) {
        showToast("error", response.data.error.error_msg); // Replace with toast notification
      } else {
        setRadio(value);
        showToast("success", "Change Success"); // Replace with toast notification
      }
    } catch (error) {
      console.error("Error:", error);
      showToast("error", "An error occurred. Please try again.");
    }
  };

  function checkPassowrd() {
    if (oldPassword == "" || newPassword == "" || confirmPassword == "") {
      showToast("error", "Please fill all the fields");
    } else {
      if (newPassword != confirmPassword) {
        showToast("error", "New password and confirm password mismatch");
      } else {
        // changePassword()
        setGoogleAuthModalPassChangeOpen(true);
      }
    }
  }

  const changePassword = async () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const changePasswordObj = {
      uuid,
      password: oldPassword,
      newPassword: newPassword,
      otp: twoFactorOtpPassChange,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/ChangePassword`,
        changePasswordObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        setTwoFactorOtpPassChange("");
      } else {
        setGoogleAuthModalPassChangeOpen(false);
        setTwoFactorOtpPassChange("");
        showToast("success", "Password Changed Successfully");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response?.data?.error === "invalid_token") {
        // //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const logout = () => {
    // const url = `/login?broker-id=${localStorage.getItem("brokerId")}`;
    localStorage.clear();
    localStorage.setItem("BROKERID", brokerID);
    navigate("/");
    window.location.reload();
  };

  const handleDeactivateAccount = async () => {
    try {
      const inputObj = {
        userId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        `${WEBSERVICE}user/blockAccount`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast(
          "success",
          "Account Deactivated Successfully. You will be logged out."
        );
        setDeactivateModal(false);
        setTimeout(() => {
          // onClose(); // Assuming onClose handles modal close
          logout(); // Assuming logout function exists
        }, 3000);
      }
    } catch (error) {
      console.error("Error deactivating account", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleDeleteAccount = async () => {
    try {
      const payload = {
        uuid: localStorage.getItem("uuid"),
        brokerId: localStorage.getItem("BROKERID"),
        requestFrom: "EXCHANGE",
      };

      const response = await axios.post(
        `${WEBSERVICE}user/userDataDeletionRequest`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast(response.data.error.error_msg);
      } else {
        showToast("success", "Data deletion process commenced successfully.");
        logout();
      }
    } catch (error) {
      console.error("Error deleting account data", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  const handleCreateAPI = () => {
    if (newKeyLabel) {
      setApiKeys([
        ...apiKeys,
        {
          name: newKeyLabel,
          id: Math.floor(Math.random() * 10000),
          publicKey: "GeneratedKeyHere",
          date: new Date().toISOString(),
          permissions: {},
          ipRestrictions: "",
        },
      ]);
      setNewKeyLabel("");
    }
  };

  const handleDeleteAPI = (id) => {
    setApiKeys(apiKeys.filter((key) => key.id !== id));
  };

  const handleDeleteAllAPI = () => {
    setApiKeys([]);
    setOpenDeleteConfirm(false);
  };

  const handleEditClick = (api) => {
    setSelectedApi(api);
    setApiName(api.keyName);
    setIpList(api.ipAddress ? api.ipAddress.split(",") : []);
    setPermissions({
      isRead: api.isRead ? 1 : 0,
      isDeposit: api.isDeposit ? 1 : 0,
      isWithdraw: api.isWithdraw ? 1 : 0,
      isSpotTrade: api.isSpotTrade ? 1 : 0,
      isFuturesTrade: api.isFuturesTrade ? 1 : 0,
      isOptionsTrade: api.isOptionsTrade ? 1 : 0,
      isBank: api.isBank ? 1 : 0,
      isP2p: api.isP2p ? 1 : 0,
      isWeb3Wallet: api.isWeb3Wallet ? 1 : 0,
      isAssetManagement: api.isAssetManagement ? 1 : 0,
      isNft: api.isNft ? 1 : 0,
      isCopyTrading: api.isCopyTrading ? 1 : 0,
    });
    setApiModifyStatus("UPDATE");
    // setIpRestriction(api.ipAddress ? "restricted" : "unrestricted");
    setEditModalOpen(true);
    setIPEnable(false);
  };

  const handleDeleteClick = (api) => {
    setApiModifyStatus("DELETE");

    var deleteapikeyObj = {};
    deleteapikeyObj["userId"] = localStorage.getItem("user_id");
    deleteapikeyObj["uuid"] = localStorage.getItem("uuid");
    deleteapikeyObj["action"] = "DELETE";
    deleteapikeyObj["id"] = api.id;

    setDeleteApiPayload(deleteapikeyObj);

    console.log("permissions", deleteapikeyObj);

    setTwofaModalApiKeyOpen(true);
    if (!isGetCodeButtonDisabled) {
      getCodeFromEmail("deleteapikey");
    }
  };

  const handleOtpPopupSubmitfor2FactorAuthApiModify = async () => {
    if (apiModifyStatus == "UPDATE") {
      editApiCall();
    }
    if (apiModifyStatus == "DELETE") {
      deleteApiKeyCall();
    }

    if (apiModifyStatus == "CREATE") {
      generateKeys();
    }
  };

  const deleteApiKeyCall = async () => {
    try {
      const deleteApiKeyObj = {
        ...deleteapikeyObj,
        securityCode: twoFactorOtpGaApiKey,
        otp: emailOtpApiModify,
        // phoneOtp: twoFactorOtpPhoneApiKey,
      };

      //   console.log('deleteApiKeyObj',deleteApiKeyObj);

      const response = await axios.post(
        `${WEBSERVICE}user/updateKeys`,
        JSON.stringify(deleteApiKeyObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        setEmailOtpApiModify("");
        setTwoFactorOtpGaApiKey("");
      } else {
        showToast("success", "Deleted successfully");
        setEmailOtpApiModify("");
        setTwoFactorOtpGaApiKey("");
        handleCloseTwofaModal();
        setEditModalOpen(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting API key:", error);
    }
  };

  const editApiCall = async () => {
    const authObj = {
      userId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
      id: selectedApi.id,
      keyName: apiName,
      apiKey: selectedApi.publicKey,
      secretKey: selectedApi.secretKey,
      securityCode: twoFactorOtpGaApiKey,
      otp: emailOtpApiModify,
      action: "UPDATE",
      isRead: isPermissionEnabled("isRead") ? (permissions.isRead ? 1 : 0) : 0,
      isDeposit: isPermissionEnabled("isDeposit") ? (permissions.isDeposit ? 1 : 0) : 0,
      isWithdraw: isPermissionEnabled("isWithdraw") ? (permissions.isWithdraw ? 1 : 0) : 0,
      isSpotTrade: isPermissionEnabled("isSpotTrade") ? (permissions.isSpotTrade ? 1 : 0) : 0,
      isFuturesTrade: isPermissionEnabled("isFuturesTrade") ? (permissions.isFuturesTrade ? 1 : 0) : 0,
      isOptionsTrade: isPermissionEnabled("isOptionsTrade") ? (permissions.isOptionsTrade ? 1 : 0) : 0,
      isBank: isPermissionEnabled("isBank") ? (permissions.isBank ? 1 : 0) : 0,
      isP2p: isPermissionEnabled("isP2p") ? (permissions.isP2p ? 1 : 0) : 0,
      isWeb3Wallet: isPermissionEnabled("isWeb3Wallet") ? (permissions.isWeb3Wallet ? 1 : 0) : 0,
      isAssetManagement: isPermissionEnabled("isAssetManagement") ? (permissions.isAssetManagement ? 1 : 0) : 0,
      isCopyTrading: isPermissionEnabled("isCopyTrading") ? (permissions.isCopyTrading ? 1 : 0) : 0,
      isNft: isPermissionEnabled("isNft") ? (permissions.isNft ? 1 : 0) : 0,

      ipAddress: ipList.length > 0 ? ipList.join(",") : "",
      // phoneOtp: twoFactorOtpPhoneApiKey,
    };


    console.log("payload", authObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/updateKeys`,
        authObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        console.error("Error:", response.data.error.error_msg);
        showToast("error", response.data.error.error_msg);
        setEmailOtpApiModify("");
        setTwoFactorOtpGaApiKey("");
      } else {
        showToast("success", "API Key Updated successfully");
        setNewlyCreatedApiKeyPublicKey("");
        handleCloseTwofaModal();
        setEmailOtpApiModify("");
        setTwoFactorOtpGaApiKey("");
        setEditModalOpen(false);
        getApiKeyList();
      }
    } catch (error) {
      showToast("error", "Something went wrong");
    }
  };

  const handlePermissionChange = (event) => {
    const { name, checked } = event.target;

    console.log(name, checked);

    setPermissions((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
    }));
  };

  const checkApiKeyAvailability = async () => {
    try {
      // Retrieve user credentials
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      // API Call
      const response = await axios.get(
        `${WEBSERVICE}user/checkApiKeyName?api_key_name=${newApiCreateName}&uuid=${uuid}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      // Check API response
      if (
        response?.data?.available === 1 ||
        response?.data?.available === "1"
      ) {
        CreateApiKey();
      } else {
        showToast(
          "error",
          "This API key name already exists and cannot be reused, even if it has been deleted. Please choose a different name."
        );
      }
    } catch (error) {
      // console.error("API Key Check Error:", error);
      // alert("Something went wrong. Please try again.");
    }
  };

  const CreateApiKey = () => {
    if (twoFactorStatus !== 0 && apiKeys.length < 15) {
      // Open modal
      setTwofaModalApiKeyOpen(true);
      setApiModifyStatus("CREATE");

      // Request email OTP if button is enabled
      if (!isGetCodeButtonDisabled) {
        getCodeFromEmail("createapikey");
      }

      // Request SMS OTP if not already sent
      // if (!isGetCodePhoneButtonDisabled) {
      //   getCodeFromPhoneSms("createapikey")();
      // }
    } else if (twoFactorStatus === 0 && apiKeys.length < 15) {
      showToast("warning", "Please turn on your two-factor authentication.");
    } else {
      showToast("error", "You have exceeded the maximum number of API keys.");
    }
  };

  const generateKeys = async () => {
    try {
      // Retrieve user credentials
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      // Prepare payload
      const payload = {
        uuid,
        otp: emailOtpApiModify,
        phoneOtp: twoFactorOtpPhoneApiKey,
        securityCode: twoFactorOtpGaApiKey,
        keyName: newApiCreateName,
      };

      // API Call
      const response = await axios.post(
        `${WEBSERVICE}user/generateKeys`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      // Check API response
      if (response?.data?.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        setEmailOtpApiModify("");
        setTwoFactorOtpGaApiKey("");
      } else {
        showToast("success", "API Created successfully!");
        getApiKeyList(); // Refresh API key list
        setEmailOtpApiModify("");
        setTwoFactorOtpPhoneApiKey("");
        setTwoFactorOtpGaApiKey("");
        handleCloseTwofaModal();

        setNewlyCreatedApiKeyName(response.data.keyName);
        setNewlyCreatedApiKeySecretKey(response.data.secretKey);
        setNewlyCreatedApiKeyPublicKey(response.data.apiKey);
      }
    } catch (error) {
      console.error("API Key Generation Error:", error);
      showToast("error", "Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    handleFilterCountry();
  }, [searchTerm]);

  const handleFilterCountry = useCallback(() => {
    if (searchTerm !== "") {
      const term = searchTerm.toLowerCase();
      const filteredData = countryFlag
        .filter(
          (country) =>
            country.country.toLowerCase().includes(term) ||
            country.value.toString().includes(term)
        )
        .sort((a, b) => {
          const aStarts = a.country.toLowerCase().startsWith(term) ? 0 : 1;
          const bStarts = b.country.toLowerCase().startsWith(term) ? 0 : 1;
          if (aStarts !== bStarts) return aStarts - bStarts;
          return a.country.toLowerCase().localeCompare(b.country.toLowerCase());
        });
      setFilterCountry(filteredData);
    } else {
      setFilterCountry(countryFlag);
    }
  }, [searchTerm, countryFlag]);

  const getUsersAllLoggedInDevices = async () => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/getUserLoggedInDetails`,
        { uuid: localStorage.getItem("uuid") },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        setUserLoggedindevices(response.data.loggedInData);
      }
    } catch (error) {
      showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
    }
  };

  const logoutFromAll = async () => {
    deviceLogout("logoutFromAllDevices", navigate);
    // try {
    //     const response = await axios.post(
    //         `${WEBSERVICE}user/getUserLoggedInDetails`,
    //         { uuid: localStorage.getItem('uuid') },
    //         {
    //             headers: { "Content-Type": "application/json", "authorization": `BEARER ${localStorage.getItem("access_token")}` }
    //         }
    //     );

    //     if (response.data.error.error_data !== 0) {
    //         showToast('error', response.data.error.error_msg);
    //     } else {

    //         setUserLoggedindevices(response.data.loggedInData)

    //     }
    // } catch (error) {
    //     alert("SESSION TIMED OUT. LOGIN AGAIN");
    // }
  };

  const getEnableDisableStatus = async () => {
    try {
      const payload = { uuid: localStorage.getItem("uuid") };
      const response = await axios.post(
        `${WEBSERVICE}transaction/getEnableDisableStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data == 0) {
        setIsWhitelistEnabled(response.data.addressWhitelistStatus);
      } else {
        setIsWhitelistEnabled(0);
        // showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      setIsWhitelistEnabled(0);
      showToast("error", "Error checking whitelist status");
    }
  };

  const changeAddressManagementSettings = async (isEnable) => {
    if (twoFactorStatus != 0 || twoFactorStatus != "0") {
      setIsAddrEnable(isEnable);

      const title = isEnable ? "Enable Whitelist" : "Disable Whitelist";
      setAddrMgmtTitle(title);
      const description = isEnable
        ? "Once this function is enabled, your account will only be able to withdraw to addresses on your whitelist."
        : "Once this function is disabled, your account won't be able to withdraw to addresses on your whitelist.";
      setAddrMgmtDescription(description);

      const confirmText = isEnable ? "Enable" : "Disable";
      setAddrMgmtConfirmText(confirmText);

      setOpenAddressManagementConfModal(true);
    } else {
      showToast("error", "Please turn on your two factor authentication");
    }
  };

  const changeFacebokAuthStatus = async (isEnable) => {
    if (twoFactorStatus != 0 || twoFactorStatus != "0") {
      if (isEnable == true) {
        setIsSocialEnable(1);
      } else {
        setIsSocialEnable(0);
      }
      setSocialAuthModalOpen(true);
      getCodeFromEmail("2fa");
    } else {
      showToast("error", "Please turn on your two factor authentication");
    }
  };

  const enableDisableAddressWhitelist = async () => {
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      securityCode: twoFactorAddrOtp,
      otp: emailOtpAddr,
      whitelistEnable: isAddrEnable ? 1 : 0,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/enableDisableAddressWhitelist`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const res = response.data;

      if (res.error?.error_data === 0) {
        showToast("success", "Settings Updated");
        setEmailOtpAddrOtp("");
        setTwoFactorAddrOtp("");
        setTimeout(() => {
          window.location.reload();
        }, 1500);

        // Open confirmation modal
        // setShowConfirmationModal(true);
      } else {
        setEmailOtpAddrOtp("");
        setTwoFactorAddrOtp("");
        showToast("error", res.error.error_msg || "Something went wrong");
      }
    } catch (error) {
      showToast("error", "API error: " + error.message);
    }
  };

  const enableDisableSocialAuth = async () => {
    console.log("calling1");

    try {
      const updateSettingObjSocial = {
        userId: localStorage.getItem("user_id"),
        lock_outgoing_transactions: lockOutgoingTransactionStatus,
        two_factor_auth: twoFactorStatus,
        rate_alert: rateAlert,
        vibrate_alert: vibrateAlert,
        incoming_transactions_alert: incomingTransactionAlert,
        pin_lock: pinLock,
        sound_alert: soundAlert,
        alert_rate: alertRate,
        facebookAuthStatus: isSocialEnable,
        uuid: localStorage.getItem("uuid"),
        securityCode: twoFactorSocialOtp,
        otp: emailOtpSocial,
      };

      const response = await axios.post(
        `${WEBSERVICE}user/SaveUserAppSettings`,
        updateSettingObjSocial,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        getUserAppSetting();

        console.log("twoFactorStatus", twoFactorStatus);

        if (isSocialEnable === 0 || isSocialEnable === "0") {
          showToast("success", "Facebook login turned off. Login Again");
        } else {
          showToast("success", "Facebook login turned on. Login Again");
        }
        setTimeout(() => {
          deviceLogout("userLogout", navigate);
        }, 400);
      }
    } catch (error) {
      showToast("error", "Could Not Connect To Server");
    }
  };

  const confirmDelete = async () => {
    const userId = localStorage.getItem("user_id");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const deleteApiKeyObj = {
      userId,
      uuid,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/deleteAllApiKeysByUser`,
        JSON.stringify(deleteApiKeyObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + accessToken,
          },
        }
      );

      const result = response.data;

      if (result.error?.error_data !== 0) {
        showToast("error", result.error.error_msg || "Something went wrong");
      } else {
        showToast("success", "List of API keys deleted successfully");
        window.location.reload();
      }
    } catch (error) {
      console.error("API delete failed:", error);
      showToast("error", "Failed to delete API keys");
    }
  };

  const handleApiKeyUpdate = () => {
    setCountdown(300);
    setTwofaModalApiKeyOpen(true);
    if (!isGetCodeButtonDisabled) {
      getCodeFromEmail("updateapikey");
    }
  };

  const handleCheckPrivecy = (e) => {
    let twoFactorAuth = localStorage.getItem("twoFactorAuth");
    if (twoFactorAuth === "1") {
      getCodeFromEmail("privacyMode");
      setPrivaacyModalOpen(true);
    } else {
      setIsPrivacyChecked(false);
      showToast(
        "error",
        "Please turn on Two Factor Authentication from Settings first"
      );
    }
  };

  const updatePrivacyStatus = async () => {
    if (emailOtpPrivacy?.length !== 8 || twoFactorOtpPrivacy?.length !== 6) {
      showToast("error", "Please provide a valid OTP & Google Auth code");
      return;
    }
    try {
      // Build payload
      const payload = {
        uuid: localStorage.getItem("uuid"),
        otp: emailOtpPrivacy,
        securityCode: twoFactorOtpPrivacy,
        privacyOn: !isPrivacyChecked ? 1 : 0,
      };

      const token = localStorage.getItem("access_token");

      const response = await axios.post(
        `${WEBSERVICE}user/updatePrivacyMode`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        // error from backend
        showToast("error", result.error.error_msg);
        setEmailOtp("");
        setTwoFactorOtp("");
      } else {
        // success
        setIsPrivacyChecked(!isPrivacyChecked);
        setPrivaacyModalOpen(false); // close modal
        showToast("success", "Privacy updated successfully");
        setEmailOtp("");
        setTwoFactorOtp("");
      }
    } catch (err) {
      console.error("Error updating privacy:", err);
      showToast("error", "Internal Server Error");
    }
  };
  const Infomodal = [
    {
      title: "2 Factor Authentication (2FA)",
      description: `Click on the toggle button to activate 2-factor authentication. A barcode will appear. You have to scan the barcode through the google authenticator app and enter the code in the below field. After that, you will be logged out automatically and the 2FA will be on for future login.`,
    },
    {
      title: "Phone number authentication",
      description: `Turn on phone authentication for added security. You will be required to turn this security feature on to withdraw crypto assets from the exchange to an external address.`,
    },
    {
      title: "Phone number authentication",
      description: `If this is turned on, you will be asked a phone OTP at login. Once you turn this on or off, you will be logged out automatically.`,
    },
    {
      title: `Enable transaction fees in ${tradingFeesCurrency}`,
      description: `To activate this feature, you must carry a minimum of 10 ${tradingFeesCurrency} in your wallet. After activating this feature your transaction fees will be deducted in ${tradingFeesCurrency} only with a 25% discount on transaction charges.`,
    },
    {
      title: "Change Password",
      description: `You can change your login password by providing your old and new passwords.`,
    },
    {
      title: "Privacy",
      description: `If you check the privacy box, your phone number and email will not be shared with any third party.`,
    },
    {
      title: "Deactivate my account",
      description: `Clicking on this button will deactivate your account account. To activate it again you have to request your admin.`,
    },
    {
      title: "Enable/Disable Facebook Login",
      description: `Click on the toggle button to activate/deactivate Facebook login. After deactivating the toggle button users can not login through Facebook but can login using email id and password. Turn the feature back ON if you want to use Facebook login.`,
    },
    {
      title: "Withdrawal Whitelist",
      description: `Click on the toggle button to activate/deactivate Withdrawal Whitelist.`,
    },
    {
      title: "Create API Keys",
      description: `You must have your 2 Factor Authentication turned on. Enter the API Key name and Click create button. The security validation popup will appear. You will find the button under the name "Get Code". Click on Get Code and type the code from the email in the email verification code field. Then enter the google authenticator code in the google verification code field and click on Submit button. Click on the Check box to give permission (Read, Deposit, Withdraw, and Trade) for API then click on the SAVE button to create the API.`,
    },
    {
      title: "Enable/Disable Facebook Login",
      description: `Click on the toggle button to activate/deactivate Facebook login.
              After deactivating the toggle button users can not login through
              Facebook but can login using email id and password.
              Turn the feature back ON if you want to use Facebook login.`,
    },
  ];

  const validatePhone = (value) => {
    if (!value) {
      return "Phone number is required";
    }
    if (!/^[0-9]+$/.test(value)) {
      return "Only numbers are allowed";
    }
    if (value.length < 8) {
      return "Phone number must be at least 8 digits";
    }
    if (value.length > 15) {
      return "Phone number must be at most 15 digits";
    }
    return "";
  };

  const handleBlur = () => {
    setShowPhoneDisclaimer(false);
    const validationError = validatePhone(phone);
    setError(validationError);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value) && value.length <= 15) {
      setPhone(value);
      const validationError = validatePhone(value);
      setError(validationError);
    }
  };

  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Box sx={pageWrapper}>
      {/* Hero Banner */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <SettingsOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Account Settings</Typography>
            <Typography sx={heroSubtitle}>
              Manage your security, authentication, preferences and API access
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* 2FA Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>
            2 Factor Authentication (2FA)
          </Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(0)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
            To secure your account, please download Google Authenticator from
            your App Store, then select the slider opposite "Log in" to slide to
            the right and it will show a popup with a QR code to scan.
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{ cursor: "pointer" }}
            className="twofabutton"
            onClick={changeStatusFor2FactorAuth}
            sx={toggleRow}
          >
            <Typography>Activate 2FA at Log in</Typography>
            <Switch
              checked={twoFactorStatus == 1}
              // onChange={(e) => toggleData(e, keys)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: btncolor, // custom thumb color
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: btncolor, // custom track color when checked
                },
              }}
            />
            {/* <FaToggleOn
              size={30}
              // color={twoFactorStatus == 1 ? "#4CAF50" : "#757575"}
              style={{
                transform:
                  twoFactorStatus == 1 ? "rotate(0deg)" : "rotate(180deg)",
              }}
            /> */}
          </Box>
        </Box>
      </Box>

      {/* Phone Authentication Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Phone Number Authentication</Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(1)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
            {`${userInfo?.userResult?.countryCode?.startsWith("+")
              ? userInfo.userResult.countryCode
              : "+" + userInfo?.userResult?.countryCode
              } ${userInfo?.userResult?.phone
                ?.toString()
                ?.slice(0, 3)}******${userInfo?.userResult?.phone
                  ?.toString()
                  ?.slice(8)}`}
          </Typography>
          <Box display="flex" gap={2} mb={2} mt={2}>
            <ContainedButton
              variant="contained"
              onClick={(e) => setPhoneChangeFirstModal(true)}
            >
              Change Phone Number
            </ContainedButton>
            {/* <Button va  riant="contained" color="primary">Send OTP</Button> */}
          </Box>
          {/* phoneAuthStatusFromUiEnd === 1 */}
          {settingFeature?.enablePhoneOtp === 1 && (
            <>
              <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
                You can enable Multi-Factor Authentication (MFA) to protect your
                account. If you do, {localStorage.getItem("exchange")} [company
                name: {brokerBasicInfo?.companyName}
                {`${brokerBasicInfo?.companyName?.includes("LLC") ? "" : " LLC"
                  }`}
                ] will send you a unique password each time you sign in. Do you
                want to enable this feature?
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                className="twofabutton"
                sx={toggleRow}
              >
                <Typography>
                  Activate phone authentication at Log in{" "}
                  <span
                    style={{
                      cursor: "pointer",
                      margin: "10px",
                    }}
                    onClick={() => handleInfoModal(2)}
                  >
                    {/* <i class="fa fa-info-circle" aria-hidden="true"></i> */}
                    <InfoIcon style={{ fontSize: "15px" }} />
                  </span>
                </Typography>
                {/* <FaToggleOn
              onClick={handleStatusForPhoneAuth}
              size={30}
              // color={phoneAuthStatusFromUiEnd == 1 ? "#4CAF50" : "#757575"}
              style={{
                cursor: "pointer",
                transform:
                  phoneAuthStatusFromUiEnd == 1
                    ? "rotate(0deg)"
                    : "rotate(180deg)",
              }}
            /> */}

                <Switch
                  checked={phoneAuthStatusFromUiEnd == 1}
                  onChange={handleStatusForPhoneAuth}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: btncolor, // custom thumb color
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: btncolor, // custom track color when checked
                    },
                  }}
                />
              </Box>{" "}
            </>
          )}
        </Box>
      </Box>

      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>
            Devices you are currently logged in from
          </Typography>
          {userLoggedindevices?.length > 1 && (
            <ContainedButton
              variant="contained"
              size="small"
              onClick={(e) => setLogoutModalShow(true)}
            >
              Logout All Devices
            </ContainedButton>
          )}
        </Box>
        <Box sx={sectionContent}>
          {/* <Typography variant="h6">Devices you are currently logged in from</Typography> */}
          <Box mt={2}>
            <DataTable
              columns={[
                "IP Address",
                "Latitude",
                "Longitude",
                "Location",
                "Browser",
                "Device Type",
                "Device Id",
                "Date-Time",
                "Status",
              ]}
            >
              {userLoggedindevices.map((device, index) => (
                <TableRow key={index}>
                  <TableCell>{device.ipAddress}</TableCell>
                  <TableCell>{device.latitude}</TableCell>
                  <TableCell>{device.longitude}</TableCell>
                  <TableCell
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    {device.location}
                  </TableCell>
                  <TableCell
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    {device.browser}
                  </TableCell>
                  <TableCell
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    {device.deviceType}
                  </TableCell>
                  <TableCell
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    <span>{device.deviceId}</span>
                  </TableCell>
                  <TableCell>{device.timestamp}</TableCell>
                  <TableCell
                    sx={{
                      color:
                        device.isLoggedIn === 0 ? "error.main" : "success.main",
                    }}
                  >
                    {device.isLoggedIn === 0 ? "Logged Out" : "Logged In"}
                  </TableCell>
                </TableRow>
              ))}
            </DataTable>
            {/* <TableContainer
              component={Paper}
              sx={{
                maxHeight: "500px",
                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <Table sx={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      IP Address
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Latitude</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Longitude</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Location</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Browser</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Device Type
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Device Id</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Date-Time</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  
                </TableBody>
              </Table>
            </TableContainer> */}
          </Box>
        </Box>
      </Box>

      {/* Enable Transaction Fees Section */}
      {settingFeature?.enableTradingFeesCurrency === 1 && (
        <Box sx={settingSection}>
          <Box sx={sectionHeader}>
            <Typography sx={sectionTitle}>
              Enable transaction fees in {tradingFeesCurrency}
            </Typography>
            <span
              style={{ cursor: "pointer", margin: "10px" }}
              onClick={() => handleInfoModal(3)}
            >
              <InfoIcon style={{ fontSize: "15px" }} />
            </span>
          </Box>
          <Box sx={sectionContent}>
            <RadioGroup
              row
              value={radio}
              onChange={(e) => handleCheck(e.target.value)}
            >
              <FormControlLabel
                value="on"
                control={<Radio color="primary" />}
                label="ON"
              />
              <FormControlLabel
                value="off"
                control={<Radio color="primary" />}
                label="OFF"
              />
            </RadioGroup>
            <Typography variant="body2" sx={{ opacity: 0.7, mt: 1 }}>
              * Save 25% in trading fees
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              * You should have a minimum balance of 10 {tradingFeesCurrency} in
              your {tradingFeesCurrency} wallet to turn this feature on
            </Typography>
          </Box>
        </Box>
      )}

      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Receive Crypto Price Alerts</Typography>
        </Box>
        <Box sx={sectionContent}>
          <Box sx={{ borderRadius: 2 }}>
            {fields.map((field, index) => (
              <Grid
                container
                spacing={2}
                alignItems="center"
                key={field.id}
                sx={{ mb: 2 }}
              >
                <Grid size={{ xs: 12, md: 2.5 }}>
                  <Typography variant="body2">
                    Send me an email alert if the price of
                  </Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 1.5 }}>
                  <Select
                    size="small"
                    fullWidth
                    {...register(`alerts.${index}.crypto`)}
                    value={watch(`alerts.${index}.crypto`)}
                    onChange={(e) =>
                      setValue(`alerts.${index}.crypto`, e.target.value)
                    }
                  >
                    {cryptoList.map((crypto) => (
                      <MenuItem key={crypto} value={crypto}>
                        {crypto}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid size={{ xs: 2, md: 0.5 }}>
                  <Typography variant="body2">goes</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 1.5 }}>
                  <Select
                    size="small"
                    fullWidth
                    {...register(`alerts.${index}.direction`)}
                    value={watch(`alerts.${index}.direction`)}
                    onChange={(e) =>
                      setValue(`alerts.${index}.direction`, e.target.value)
                    }
                  >
                    <MenuItem value="Up">Up</MenuItem>
                    <MenuItem value="Down">Down</MenuItem>
                  </Select>
                </Grid>

                <Grid size={{ xs: 2, md: 0.5 }}>
                  <Typography variant="body2">by</Typography>
                </Grid>

                <Grid size={{ xs: 4, md: 1.5 }}>
                  <Controller
                    name={`alerts.${index}.percentage`}
                    control={control}
                    defaultValue={5}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        size="small"
                        fullWidth
                        type="number"
                        onChange={(e) =>
                          field.onChange(validatePercentage(e.target.value))
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid size={{ xs: 2, md: 0.5 }}>
                  <Typography variant="body2">%</Typography>
                </Grid>

                {/* Remove button only for user-added alerts */}
                {field.isNew && (
                  <Grid size={{ xs: 4, md: 1.5 }}>
                    <OutlinedButton
                      variant="outlined"
                      fullWidth
                      size="small"
                      onClick={() => remove(index)}
                    >
                      Remove
                    </OutlinedButton>
                  </Grid>
                )}

                {/* Save Alert button with label based on isNew */}
                <Grid size={{ xs: 4, md: 1.5 }}>
                  <ContainedButton
                    variant="contained"
                    fullWidth
                    size="small"
                    // color={field.isNew ? "primary" : "success"}
                    onClick={() => field.isNew && saveAlert(index)}
                    disabled={!field.isNew}
                  >
                    {field.isNew ? "Save Alert" : "Alert Saved"}
                  </ContainedButton>
                </Grid>
              </Grid>
            ))}

            <Grid container sx={{ mt: 2 }}>
              <Grid item>
                <ContainedButton
                  variant="contained"
                  size="small"
                  onClick={() =>
                    append({
                      crypto: "",
                      direction: "Up",
                      percentage: 5,
                      isNew: true,
                    })
                  }
                >
                  + Add
                </ContainedButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      {/* Change Password Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Change password</Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(4)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Box sx={{ maxWidth: "100%", mx: "auto" }}>
            <Box
              display="flex"
              gap={2}
              mt={2}
              flexDirection={{ xs: "column", md: "row" }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Old Password"
                value={oldPassword}
                onChange={handleOldPasswordChange}
                onBlur={handleOldPasswordBlur}
                type={showOldPassword ? "text" : "password"}
                error={touched.oldPassword && !!errorss.oldPassword}
                helperText={touched.oldPassword ? errorss.oldPassword : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowOldPassword(!showOldPassword)}
                        edge="end"
                        size="small"
                      >
                        {showOldPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldStyles}
              />

              <TextField
                fullWidth
                variant="outlined"
                label="New Password"
                value={newPassword}
                onChange={handleNewPasswordChange}
                onBlur={handleNewPasswordBlur}
                type={showNewPassword ? "text" : "password"}
                error={touched.newPassword && !!errorss.newPassword}
                helperText={touched.newPassword ? errorss.newPassword : ""}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        edge="end"
                        size="small"
                      >
                        {showNewPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldStyles}
              />

              <TextField
                fullWidth
                variant="outlined"
                label="Confirm Password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                onBlur={handleConfirmPasswordBlur}
                type={showConfirmPassword ? "text" : "password"}
                error={touched.confirmPassword && !!errorss.confirmPassword}
                helperText={
                  touched.confirmPassword ? errorss.confirmPassword : ""
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                        size="small"
                      >
                        {showConfirmPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldStyles}
              />
            </Box>

            {/* Password Matched Indicator - only show when both fields have content */}
            {shouldShowMatchedMessage && (
              <Typography
                sx={{ color: "green", fontSize: "0.75rem", mt: 1, ml: 0.5 }}
              >
                ✓ Passwords Matched
              </Typography>
            )}

            {/* Password Requirements Hint - only show when typing and not meeting criteria */}
            {newPassword && showPasswordHint && (
              <Alert
                severity="info"
                sx={{
                  mt: 1,
                  fontSize: "0.75rem",
                  "& .MuiAlert-message": { fontSize: "0.75rem" },
                }}
              >
                Password must be 8-35 characters with uppercase, lowercase,
                number, and one special character ($ @ . !)
              </Alert>
            )}

            <Box mt={3}>
              <ContainedButton
                variant="contained"
                onClick={checkPassword}
                disabled={
                  !oldPassword ||
                  !newPassword ||
                  !confirmPassword ||
                  !isMatched ||
                  !passwordRegex.test(newPassword)
                }
                fullWidth
                sx={{
                  py: 1.5,
                  textTransform: "none",
                  fontSize: "1rem",
                  "&.Mui-disabled": {
                    backgroundColor: "#b0b0b0",
                    color: "#ffffff",
                  },
                }}
              >
                Change Password
              </ContainedButton>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Privacy Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Privacy</Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(5)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Box mt={2}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              If you check the privacy box, your phone number and email will not
              be shared with any third party.
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={isPrivacyChecked}
                  onChange={handleCheckPrivecy}
                />
              }
              label="Do not display my contact info to any third party."
            />
          </Box>
        </Box>
      </Box>

      {/* Deactivate Account Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Deactivate my account</Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(6)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Box mt={2}>
            <ContainedButton
              variant="contained"
              onClick={(e) => setDeactivateModal(true)}
            >
              Deactivate
            </ContainedButton>
          </Box>
        </Box>
      </Box>

      {/* Delete My Data Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Delete my data</Typography>
        </Box>
        <Box sx={sectionContent}>
          <Box mt={2}>
            <ContainedButton
              variant="contained"
              onClick={() => setDeleteDataModal(true)}
            >
              Delete
            </ContainedButton>
          </Box>
        </Box>
      </Box>

      {/* Withdrawal Whitelist Section */}
      <Box sx={settingSection}>
        <Box sx={sectionHeader}>
          <Typography sx={sectionTitle}>Withdrawal Whitelist</Typography>
          <span
            style={{ cursor: "pointer", margin: "10px" }}
            onClick={() => handleInfoModal(8)}
          >
            <InfoIcon style={{ fontSize: "15px" }} />
          </span>
        </Box>
        <Box sx={sectionContent}>
          <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
            Once this function is enabled, your account will only be able to
            withdraw to addresses on your whitelist.
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{ cursor: "pointer" }}
            className="twofabutton"
            sx={toggleRow}
          >
            <Link
              to="/address-management"
              sx={{ color: "#2196f3", border: "none" }}
              className="no-underline"
            >
              Address Management
            </Link>

            <Switch
              checked={isWhitelistEnabled !== 0}
              onChange={(e) =>
                changeAddressManagementSettings(e.target.checked)
              }
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: btncolor, // custom thumb color
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: btncolor, // custom track color when checked
                },
              }}
            />

            {/* {isWhitelistEnabled == 0 ? (
              <FaToggleOn
                onClick={(e) => changeAddressManagementSettings(true)}
                size={30}
                // color={twoFactorStatus == 1 ? "#4CAF50" : "#757575"}
                style={{
                  transform: "rotate(180deg)",
                }}
              />
            ) : (
              // <Switch
              //   color="primary"
              //   onChange={() => changeAddressManagementSettings(true)}
              // />

              // <Switch
              //   checked
              //   color="primary"
              //   onChange={() => changeAddressManagementSettings(false)}

              // />
              <FaToggleOn
                onClick={() => changeAddressManagementSettings(false)}
                size={30}
                style={{
                  cursor: "pointer",
                  transform: "rotate(0deg)",
                }}
              />
            )} */}
          </Box>
        </Box>
      </Box>

      {/* Facebook Login Section */}
      {brokerSocialLogin && (
        <Box sx={settingSection}>
          <Box sx={sectionHeader}>
            <Typography sx={sectionTitle}>
              Enable/Disable Facebook Login
            </Typography>
            <span
              style={{ cursor: "pointer", margin: "10px" }}
              onClick={() => handleInfoModal(10)}
            >
              <InfoIcon style={{ fontSize: "15px" }} />
            </span>
          </Box>
          <Box sx={sectionContent}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              style={{ cursor: "pointer" }}
              className="twofabutton"
              sx={toggleRow}
            >
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                Activate/Deactivate Facebook at Log in
              </Typography>

              <Switch
                checked={facebookLoginEnableDisableStatus !== 0}
                onChange={(e) => changeFacebokAuthStatus(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: btncolor, // custom thumb color
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: btncolor, // custom track color when checked
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      )}

      {/* API Key Sections */}
      {settingFeature?.enableApiKey === 1 && (
        <>
          {/* Create API Section */}
          <Box sx={settingSection}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>Create API</Typography>
              <span
                style={{ cursor: "pointer", margin: "10px" }}
                onClick={() => handleInfoModal(9)}
              >
                <InfoIcon style={{ fontSize: "15px" }} />
              </span>
            </Box>
            <Box sx={sectionContent}>
              <Box mt={2}>
                <TextField
                  label="Enter key label"
                  variant="outlined"
                  autoComplete="off"
                  onChange={(e) => setNewApiCreateName(e.target.value)}
                  onKeyPress={(e) => {
                    const regex = /^[a-zA-Z ]+$/;
                    if (!regex.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                <ContainedButton
                  variant="contained"
                  onClick={(e) => checkApiKeyAvailability()}
                  sx={{
                    height: "55px",
                    marginLeft: { xs: "5px", md: "20px" },
                    mt: { xs: 2, md: 0 },
                  }}
                >
                  Create
                </ContainedButton>
              </Box>

              {newlyCreatedApiKeyPublicKey != "" ? (
                <Box>
                  <Box mb={2} mt={2}>
                    <Typography variant="subtitle1">API Key</Typography>
                    <Grid container spacing={1} alignItems="center">
                      <Grid size={{ xs: 11, md: 6 }}>
                        <TextField
                          fullWidth
                          value={newlyCreatedApiKeyPublicKey}
                          InputProps={{ readOnly: true }}
                          variant="filled"
                          size="small"
                          sx={{
                            input: {
                              color: theme === "dark" ? "#fff" : "#000",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={1}>
                        <ContainedButton
                          onClick={() => {
                            navigator.clipboard.writeText(
                              newlyCreatedApiKeyPublicKey
                            );
                            showToast("success", "Copied");
                          }}
                        >
                          <ContentCopyIcon
                            sx={{ color: "var(--text-color)" }}
                          />
                        </ContainedButton>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mb={2}>
                    <Typography variant="subtitle1">Secret Key</Typography>
                    <Grid container spacing={1} alignItems="center">
                      <Grid size={{ xs: 11, md: 6 }}>
                        <TextField
                          fullWidth
                          value={newlyCreatedApiKeySecretKey}
                          InputProps={{ readOnly: true }}
                          variant="filled"
                          size="small"
                          sx={{
                            input: {
                              color: theme === "dark" ? "#fff" : "#000",
                            },
                          }}
                        />
                      </Grid>
                      <Grid size={1}>
                        <ContainedButton
                          onClick={() => {
                            navigator.clipboard.writeText(
                              newlyCreatedApiKeySecretKey
                            );
                            showToast("success", "Copied");
                          }}
                        >
                          <ContentCopyIcon
                            sx={{ color: "var(--text-color)" }}
                          />
                        </ContainedButton>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box mt={2}>
                    <Typography variant="subtitle1" gutterBottom>
                      API Permissions
                    </Typography>
                    <FormGroup row sx={{ color: "#fff" }}>
                      {Object.keys(permissionsNew)
                        .filter(isPermissionEnabled)
                        .map((key) => (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                readOnly
                                disabled
                                checked={permissionsNew[key]}
                                name={key}
                                sx={{ color: "#90caf9" }}
                              />
                            }
                            label={key.toUpperCase().replace("_", " ")}
                          />
                        ))}
                    </FormGroup>
                  </Box>
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Box>

          {/* API List Section */}
          <Box sx={settingSection}>
            <Box sx={sectionHeader}>
              <Typography sx={sectionTitle}>API List</Typography>
              {apiKeys.length > 0 ? (
                <OutlinedButton
                  variant="outlined"
                  onClick={() => setDeleteAllApiModal(true)}
                >
                  Delete All
                </OutlinedButton>
              ) : (
                <OutlinedButton disabled variant="outlined">
                  Delete All
                </OutlinedButton>
              )}
            </Box>
            <Box sx={sectionContent}>
              <Box mt={2}>
                <DataTable
                  columns={[
                    "Name",
                    "Id",
                    "Public Key",
                    "Date",
                    "API Permissions",
                    "Accessible IPS",
                    "Actions",
                  ]}
                >
                  {apiKeys.map((api) => (
                    <TableRow
                      key={api.id}
                      sx={{
                        verticalAlign: "top",
                        borderBottom: `7px solid ${theme === "dark" ? "black" : "#d2caca"
                          }`,
                      }}
                    >
                      <TableCell>{api.keyName}</TableCell>
                      <TableCell>{api.id}</TableCell>
                      <TableCell>
                        <Typography
                          style={{
                            wordWrap: "break-word",
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {api.publicKey}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {new Date(api.createdOn).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        {/* Dynamic permission field mapping */}
                        {(() => {
                          function getPermissionField(apiTypeName) {
                            // "SPOT TRADE" -> "isSpotTrade"
                            return (
                              "is" +
                              apiTypeName
                                .toLowerCase()
                                .split(" ")
                                .map((word, idx) =>
                                  idx === 0
                                    ? word.charAt(0).toUpperCase() +
                                    word.slice(1)
                                    : word.charAt(0).toUpperCase() +
                                    word.slice(1)
                                )
                                .join("")
                            );
                          }
                          return (
                            <Grid container spacing={1}>
                              {apiTypeList &&
                                apiTypeList.map((type) => {
                                  const permField = getPermissionField(
                                    type.apiTypeName
                                  );
                                  return (
                                    <Grid size={6} key={type.apiTypeId}>
                                      <Checkbox
                                        checked={api[permField] === 1}
                                        disabled
                                      />
                                      {type.apiTypeName}
                                    </Grid>
                                  );
                                })}
                            </Grid>
                          );
                        })()}
                      </TableCell>
                      <TableCell>{api.ipAddress}</TableCell>
                      <TableCell>
                        <Box display="flex" justifyContent="space-between">
                          <ContainedButton
                            variant="contained"
                            size="small"
                            style={{ marginRight: "5px" }}
                            onClick={() => handleEditClick(api)}
                          >
                            Edit
                          </ContainedButton>
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() => handleDeleteClick(api)}
                          >
                            Delete
                          </ContainedButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </DataTable>

                {selectedApi && (
                  <Dialog
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                  >
                    <DialogTitle
                      display={"flex"}
                      justifyContent="center"
                      alignItems="center"
                      sx={{ p: 2 }}
                    >
                      <span>Edit API</span>
                    </DialogTitle>

                    <DialogContent>
                      <TextField
                        label="API Name"
                        fullWidth
                        margin="normal"
                        value={apiName}
                        onChange={(e) => setApiName(e.target.value)}
                      />
                      <TextField
                        label="Public Key"
                        fullWidth
                        margin="normal"
                        value={selectedApi.publicKey}
                        disabled
                      />
                      <TextField
                        label="Secret Key"
                        fullWidth
                        margin="normal"
                        value="****************"
                        disabled
                      />
                      <Typography>API Permissions</Typography>
                      <Grid container spacing={1}>
                        {Object.keys(permissions)
                          .filter(isPermissionEnabled)
                          .map((perm) => {
                            // Format label: remove 'is', add space before capital letters, trim, and uppercase first letter only
                            const label = perm
                              .replace(/^is/, "")
                              .replace("Trade", "")
                              .replace(/([A-Z])/g, " $1")
                              .replace(/  +/g, " ")
                              .trim()
                              .replace(/^./, (str) => str.toUpperCase());
                            return (
                              <Grid size={6} key={perm}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={permissions[perm] === 1}
                                      onChange={handlePermissionChange}
                                      name={perm}
                                    />
                                  }
                                  label={label.toUpperCase()}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                      <Typography>IP Access Restrictions</Typography>
                      <RadioGroup
                        value={ipRestriction}
                        onChange={(e) => (
                          setIpRestriction(e.target.value), setIPEnable(false)
                        )}
                      >
                        <FormControlLabel
                          value="unrestricted"
                          control={<Radio />}
                          label="Unrestricted (Less Secure)"
                        />
                        <FormControlLabel
                          value="restricted"
                          control={<Radio />}
                          label="Restrict access to trusted IPs only (Recommended)"
                        />
                      </RadioGroup>
                      {ipRestriction === "restricted" && (
                        <>
                          <TextField
                            label="Add IP"
                            fullWidth
                            margin="normal"
                            onKeyPress={handleAddIp}
                            helperText='Press "Enter" to add new IP address'
                          />
                          <Grid container spacing={1}>
                            {ipList.map((ip) => (
                              <Grid item key={ip}>
                                <Chip
                                  label={ip}
                                  onDelete={() => handleDeleteIp(ip)}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}
                    </DialogContent>
                    <DialogActions
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <ContainedButton
                        variant="contained"
                        onClick={() => handleApiKeyUpdate()}
                        disabled={
                          (ipRestriction === "restricted" && !isIPEnable) ||
                          (ipRestriction === "restricted" &&
                            ipList.length === 0)
                        }
                      >
                        Update
                      </ContainedButton>

                      <ContainedButton
                        onClick={() => setEditModalOpen(false)}
                        variant="contained"
                      >
                        Close
                      </ContainedButton>
                    </DialogActions>
                  </Dialog>
                )}
              </Box>
            </Box>
          </Box>
        </>
      )}

      {/* OTP Modal */}
      <Dialog
        open={phoneChangeFirstModal}
        onClose={() => setPhoneChangeFirstModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">
            {!isPrevMobileOtpSent ? "New phone number" : "Change Phone number"}
          </Typography>

          <IconButton onClick={() => setPhoneChangeFirstModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            minHeight: "200px",
            mt: 3,
            display: "flex",
            alignItems: "center",
          }}
        >
          {!isPrevMobileOtpSent ? (
            <Box sx={{ width: "100%" }}>
              <Form>
                <Form.Group controlId="phone" className="mb-3">
                  <Form.Group controlId="phone" className="mb-3">
                    <InputGroup>
                      <div style={{ position: "relative" }}>
                        <div
                          onClick={() => setIsOpen(!isOpen)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px 0 0 5px",
                            cursor: "pointer",
                            height: "55px",
                            borderRight: "none",
                          }}
                        >
                          <img
                            src={selectedCountry?.flag || countryFlag[0]?.flag}
                            alt={selectedCountry?.code || countryFlag[0]?.code}
                          />
                        </div>

                        {/* Dropdown menu */}
                        {isOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "360px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              background: "#fff",
                              zIndex: 1000,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {/* Search bar */}
                            <input
                              type="text"
                              placeholder="Search country"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              style={{
                                width: "100%",
                                padding: "10px",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                outline: "none",
                              }}
                            />
                            {/* Country list */}
                            {filteredCountries &&
                              filteredCountries.length !== 0 ? (
                              filteredCountries.map((country) => (
                                <div
                                  // key={country.value}
                                  onClick={() => {
                                    setSelectedCountry(country);
                                    setIsOpen(false);
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px",
                                    cursor: "pointer",
                                    background:
                                      selectedCountry?.value === country?.value
                                        ? "#f0f0f0"
                                        : "#fff",
                                  }}
                                >
                                  <img
                                    src={country?.flag}
                                    alt={country?.code}
                                  />
                                  &nbsp;
                                  <span
                                    style={{ color: "#555" }}
                                  >{`+(${country?.value})`}</span>
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      color: "#555",
                                    }}
                                  >
                                    {country?.country}
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div style={{ padding: "10px", color: "#888" }}>
                                No results found
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <PhoneInput
                        country={selectedCountry?.code || "us"}
                        value={
                          (selectedCountry?.value ||
                            (countryFlag && countryFlag[0]?.value) ||
                            "") + (phone || "")
                        }
                        onChange={(value, country) => {
                          const dialCode = country.dialCode;
                          let onlyNumber = value;
                          if (value.startsWith(dialCode)) {
                            onlyNumber = value.slice(dialCode.length);
                          }
                          setPhone(onlyNumber);
                          const validationError = validatePhone(onlyNumber);
                          setError(validationError);
                        }}
                        onBlur={() => {
                          setShowPhoneDisclaimer(false);
                          const validationError = validatePhone(phone);
                          setError(validationError);
                        }}
                        onFocus={() => setShowPhoneDisclaimer(true)}
                        disableDropdown={true}
                        placeholder="Enter New Phone Number"
                        inputClass={`form-control ${error ? "is-invalid" : ""}`}
                        containerStyle={{ flex: 1 }}
                        buttonStyle={{ display: "none" }}
                        inputStyle={{
                          width: "100%",
                          height: "55px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          fontSize: "16px",
                          paddingLeft: "10px",
                        }}
                      />
                    </InputGroup>
                    {error && <p className="text-danger">{error}</p>}
                  </Form.Group>
                </Form.Group>
              </Form>
            </Box>
          ) : (
            ""
          )}

          {isPrevMobileOtpSent ? (
            <Box>
              <Box className="form-group" mb={3}>
                <Typography variant="body1">
                  Input OTP from your <b>registered phone number</b>
                </Typography>
                <Typography variant="body2">
                  We sent a text message to you at{" "}
                  {userInfo?.userResult?.countryCode}
                  {userInfo?.userResult?.phone}. Enter the eight-digit code in
                  that message to confirm your phone number.
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  placeholder="Enter OTP from registered phone"
                  autoComplete="off"
                  value={smsOtpForRegisteredNo}
                  onKeyDown={(e) => {
                    // Allow: digits (0-9), Backspace, Tab, Arrow keys, Delete
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Tab" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Delete"
                    ) {
                      e.preventDefault(); // block all other keys
                    }
                  }}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^[0-9]{0,8}$/.test(input)) {
                      setSmsOtpForRegisteredNo(input);
                    }
                  }}
                  autoFocus
                  sx={{
                    mt: 1,
                  }}
                />
              </Box>

              {/* OTP for New Phone */}
              <Box className="form-group">
                <Typography variant="body1">
                  Input OTP from your <b>new phone number</b>
                </Typography>
                <Typography variant="body2">
                  We sent a text message to you at +
                  {selectedCountry?.value + editablePhone}. Enter the
                  eight-digit code in that message to confirm your phone number.
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  autoComplete="off"
                  placeholder="Enter OTP from new phone"
                  value={smsOtpForNewNo}
                  onKeyDown={(e) => {
                    // Allow: digits (0-9), Backspace, Tab, Arrow keys, Delete
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Tab" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Delete"
                    ) {
                      e.preventDefault(); // block all other keys
                    }
                  }}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^[0-9]{0,8}$/.test(input)) {
                      setSmsOtpForNewNo(input);
                    }
                  }}
                  sx={{
                    mt: 1,
                  }}
                />
                <Box display="flex" justifyContent="center" mt={2}>
                  <ContainedButton
                    variant="contained"
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => handleSendOtpInSmsParent()}
                    disabled={isGetCodePhoneButtonDisabled}
                  >
                    {isGetCodePhoneButtonDisabled
                      ? `Resend in ${countdownPhone}s`
                      : "Get OTP"}
                  </ContainedButton>
                </Box>
              </Box>
            </Box>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {!isPrevMobileOtpSent ? (
            <ContainedButton
              variant="contained"
              disabled={!phone || error}
              onClick={() => handleSendOtpInSmsParent()}
            >
              Send OTP
            </ContainedButton>
          ) : (
            <ContainedButton
              variant="contained"
              disabled={
                smsOtpForNewNo.length !== 8 ||
                smsOtpForRegisteredNo.length !== 8
              }
              onClick={() => confirmOtpCallbackForVerifyingNewMobile()}
            >
              Confirm
            </ContainedButton>
          )}
        </DialogActions>
      </Dialog>

      <Dialog open={otpModalOpen} onClose={() => setOtpModalOpen(false)}>
        <DialogTitle>Input OTP from your registered phone number</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            We sent a text message to you at 1234567899. Enter the eight-digit
            code in that message to confirm your phone number.
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Enter OTP from registered phone"
            sx={{ mb: 2, mt: 1 }}
          />
          <Typography variant="body2" sx={{ mb: 2 }}>
            We sent a text message to you at +166666666. Enter the eight-digit
            code in that message to confirm your phone number.
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Enter OTP from new phone"
            sx={{ mb: 2, mt: 1 }}
          />
          <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
            Resend in 284 seconds
          </Typography>
        </DialogContent>
        <DialogActions>
          <ContainedButton variant="contained">Send OTP</ContainedButton>
          <ContainedButton variant="contained">Confirm</ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={twofaModalOpen}
        onClose={() => setTwofaModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Authentication</Typography>
          <IconButton onClick={() => setTwofaModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2">
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              label="OTP"
              type="number"
              autoComplete="off"
              value={emailOtp}
              onChange={(e) => {
                const nextEmail = e.target.value.replace(/\D/g, "").slice(0, 8);
                // allow re-attempts after any edit
                autoSubmittedRef.current = false;
                setEmailOtp(nextEmail);

                const needs2FA =
                  exist2FaKey === "1" ||
                  exist2FaKey === 1 ||
                  specificModalStatus === "post";
                const noError =
                  !messageOtpSpecific || messageOtpSpecific.trim() === "";

                if (
                  !autoSubmittedRef.current &&
                  nextEmail.length === 8 &&
                  (!needs2FA || (twoFactorOtp || "").length === 6) &&
                  noError
                ) {
                  autoSubmittedRef.current = true;
                  // if (specificModalStatus === "pre") {
                  //   handleOtpPopupSubmitfor2FactorAuth();
                  // } else {
                  //   updateUserAppSettings();
                  //   setTwofaModalOpen(false);
                  // }
                }
              }}
              onWheel={(e) => e.target.blur()}
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />
            <ContainedButton
              variant="contained"
              onClick={() => getCodeFromEmail("2fa")}
              disabled={isGetCodeButtonDisabled}
              sx={{
                whiteSpace: "nowrap",
                width: "125px",
              }} // Prevents text from wrapping
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          <Typography variant="body2" color="error" mt={1}>
            {messageOtpSpecific}
          </Typography>

          {(exist2FaKey === "1" ||
            exist2FaKey === 1 ||
            specificModalStatus === "post") && (
              <>
                <Typography variant="body2" mt={2}>
                  Input OTP from your Google Authenticator
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Two-Factor Authenticator Code"
                  type="number"
                  autoComplete="off"
                  value={twoFactorOtp}
                  onChange={(e) => {
                    const nextTwoFA = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 6);
                    autoSubmittedRef.current = false;
                    setTwoFactorOtp(nextTwoFA);

                    const needs2FA =
                      exist2FaKey === "1" ||
                      exist2FaKey === 1 ||
                      specificModalStatus === "post";
                    const noError =
                      !messageOtpSpecific || messageOtpSpecific.trim() === "";

                    if (
                      needs2FA &&
                      !autoSubmittedRef.current &&
                      (emailOtp || "").length === 8 &&
                      nextTwoFA.length === 6 &&
                      noError
                    ) {
                      autoSubmittedRef.current = true;
                      if (specificModalStatus === "pre") {
                        handleOtpPopupSubmitfor2FactorAuth();
                      } else {
                        updateUserAppSettings();
                        setTwofaModalOpen(false);
                      }
                    }
                  }}
                  sx={{ mt: 1 }}
                />
              </>
            )}
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          {specificModalStatus === "pre" ? (
            <ContainedButton
              variant="contained"
              disabled={
                !(emailOtp?.length === 8) ||
                ((exist2FaKey === 1 ||
                  exist2FaKey === "1" ||
                  specificModalStatus === "post") &&
                  !(twoFactorOtp?.length === 6))
              }
              onClick={handleOtpPopupSubmitfor2FactorAuth}
            >
              Confirm
            </ContainedButton>
          ) : (
            <ContainedButton
              variant="contained"
              disabled={!(emailOtp?.length === 8 && twoFactorOtp?.length === 6)}
              onClick={() => {
                console.log("Updating user app settings");
                updateUserAppSettings();
                setTwofaModalOpen(false);
              }}
            >
              Confirm
            </ContainedButton>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={privaacyModalOpen}
        onClose={() => setPrivaacyModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Authentication</Typography>
          <IconButton onClick={() => setPrivaacyModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2">
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              label="OTP"
              type="number"
              autoComplete="off"
              value={emailOtpPrivacy}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                setEmailOtpPrivacy(value);
              }}
              onWheel={(e) => e.target.blur()}
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />
            <ContainedButton
              variant="contained"
              sx={{
                whiteSpace: "nowrap",
                width: "125px",
              }}
              onClick={() => getCodeFromEmail("2fa")}
              disabled={isGetCodeButtonDisabled}
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          <Typography variant="body2" color="error" mt={1}>
            {messageOtpSpecific}
          </Typography>

          <Typography variant="body2" mt={2}>
            Input OTP from your Google Authenticator
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Two-Factor Authenticator Code"
            type="number"
            autoComplete="off"
            value={twoFactorOtpPrivacy}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);
              setTwoFactorOtpPrivacy(value);
            }}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            variant="contained"
            disabled={!emailOtpPrivacy || !twoFactorOtpPrivacy}
            onClick={() => updatePrivacyStatus()}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={googleAuthModalOpen}
        onClose={() => setGoogleAuthModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 3,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          Scan QR in Google Authenticator
        </DialogTitle>

        <DialogContent>
          {/* Instruction */}
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              fontWeight: 500,
              color: "#ff6f61", // warning color
              mb: 3,
            }}
          >
            Please do not click the back button or reload the page.
          </Typography>

          {/* QR Code */}

          <Box display="flex" justifyContent="center" mb={3} mt={3}>
            <Box>
              <QRCodeCanvas
                value={twoFactorAuthKey}
                size={256}
                level="M"
                includeMargin={true}
              />
            </Box>
          </Box>

          {/* OTP Input */}
          <TextField
            fullWidth
            variant="outlined"
            label="Enter 6-digit Authenticator Code"
            value={googleAuthOtp}
            onChange={(e) => setGoogleAuthOtp(e.target.value)}
            autoComplete="off"
          />

          {/* Submit Button */}
          <ContainedButton
            variant="contained"
            fullWidth
            size="large"
            disabled={!googleAuthOtp}
            onClick={sendGoogleAuthOtp}
            sx={{ mb: 3, mt: 3 }}
          >
            Submit
          </ContainedButton>

          {/* Recovery Instruction */}
          <Typography
            variant="body2"
            sx={{
              fontSize: "13px",
              mb: 1,
            }}
          >
            Save this recovery key. You’ll need it to log in if you lose access
            to your device:
          </Typography>

          {/* Recovery Key Box */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              backgroundColor: theme === "dark" ? "#2c2c2c" : "#e6e4e4",
              border: "1px dashed #666",
              borderRadius: 2,
              p: 1.5,
              mt: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: "monospace",
                fontSize: "14px",
                wordBreak: "break-all",
              }}
            >
              {twoFactorSecureToken}
            </Typography>
            <OutlinedButton
              size="small"
              variant="outlined"
              onClick={copySecureCode}
              sx={{
                ml: 2,
              }}
            >
              Copy
            </OutlinedButton>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={googleAuthModalPassChangeOpen}
        onClose={() => (
          setGoogleAuthModalPassChangeOpen(false), setTwoFactorOtpPassChange("")
        )}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Authentication</Typography>
          <IconButton
            onClick={() => (
              setGoogleAuthModalPassChangeOpen(false),
              setTwoFactorOtpPassChange("")
            )}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Input OTP from your Google Authenticator
          </Typography>

          <TextField
            fullWidth
            type="number"
            variant="outlined"
            placeholder="Two-Factor Authenticator Code"
            value={twoFactorOtpPassChange}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setTwoFactorOtpPassChange(value);
            }}
            onWheel={(e) => e.target.blur()}
            autoComplete="off"
            autoFocus
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            fullWidth
            variant="contained"
            sx={{ margin: "16px" }}
            onClick={twoFactorOtpPassChange.length === 6 && changePassword()}
            disabled={twoFactorOtpPassChange == ""}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deactivateModal}
        onClose={() => setDeactivateModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span></span>

          <span>Deactivate Account</span>
          <IconButton onClick={() => setDeactivateModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography mt={2}>
            This process is irreversible. You will lose access to your account
            and all your data will be deleted. Are you sure you want to
            deactivate your account?
          </Typography>
        </DialogContent>
        <DialogActions>
          <ContainedButton
            variant="contained"
            onClick={() => handleDeactivateAccount()}
          >
            Yes, I want to deactivate
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDataConfirmModal}
        onClick={() => setDeleteDataConfirmModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Confirm Deletion</span>
          <IconButton onClick={() => setDeleteDataConfirmModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>
            This process is irreversible. If you proceed, your data will be
            permanently deleted, and you will lose access to your account
            immediately. Are you sure you wish to proceed?
          </Typography>
        </DialogContent>
        <DialogActions>
          <ContainedButton variant="contained" onClick={handleDeleteAccount}>
            Delete my data
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            onClick={() => setDeleteDataConfirmModal(false)}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDataModal}
        onClose={() => setDeleteDataModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span></span>

          <span>Delete Data</span>
          <IconButton onClick={() => setDeleteDataModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography mt={2}>
            Are you sure you want to delete your data?
          </Typography>
        </DialogContent>
        <DialogActions>
          <ContainedButton
            variant="contained"
            onClick={() => setDeleteDataConfirmModal(true)}
          >
            Yes, I want to delete
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            onClick={() => setDeleteDataModal(false)}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={logoutModalShow}
        onClose={() => setLogoutModalShow(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span></span>

          <span>Confirm</span>
          <IconButton onClick={() => setLogoutModalShow(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography mt={2}>
            Select "Logout" below if you are ready to log out from all devices
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ContainedButton variant="contained" onClick={() => logoutFromAll()}>
            Logout
          </ContainedButton>
          <OutlinedButton
            variant="outlined"
            onClick={() => setLogoutModalShow(false)}
          >
            Cancel
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        // twofaModalApiKeyOpen
        open={twofaModalApiKeyOpen}
        onClose={() => handleCloseTwofaModal()}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ visibility: "hidden" }}>S</span>
            <span>Security Authentication</span>
            <IconButton onClick={() => handleCloseTwofaModal()}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2">
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              label="OTP"
              type="number"
              value={emailOtpApiModify}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                setEmailOtpApiModify(value);
              }}
              onWheel={(e) => e.target.blur()}
              autoComplete="off"
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />
            <ContainedButton
              variant="contained"
              onClick={() => getCodeFromEmail("updateapikey")}
              disabled={isGetCodeButtonDisabled}
              sx={{
                whiteSpace: "nowrap",
                // width: "125px",
              }} // Prevents text from wrapping
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          <Typography variant="body2" color="error" mt={1}>
            {messageOtpSpecific}
          </Typography>

          {/* <Typography variant="body2">
            Input OTP from your registered phone number
          </Typography>

          <Box display="flex" gap={2} mt={1}>
            <TextField
              variant="outlined"
              label="OTP"
              type="password"
              value={twoFactorOtpPhoneApiKey}
              onChange={(e) => setTwoFactorOtpPhoneApiKey(e.target.value)}
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => getCodeFromPhoneSms("updateapikey")}
              disabled={isGetCodePhoneButtonDisabled}
              sx={{ whiteSpace: "nowrap", width: "125px" }} // Prevents text from wrapping
            >
              {isGetCodePhoneButtonDisabled
                ? `Resend in ${countdownPhone}s`
                : "Get Code"}
            </Button>
          </Box> */}

          {/* <Typography variant="body2" color="error" mt={1}>
            {messagePhoneOtpSpecific}
          </Typography>  */}

          <Typography variant="body2" mt={2}>
            Input OTP from your Google Authenticator
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label="Two-Factor Authenticator Code"
            type="number"
            autoComplete="off"
            value={twoFactorOtpGaApiKey}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);
              setTwoFactorOtpGaApiKey(value);
            }}
            sx={{ mt: 1 }}
          />
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <ContainedButton
              variant="contained"
              disabled={emailOtpApiModify == "" || twoFactorOtpGaApiKey == ""}
              onClick={() => handleOtpPopupSubmitfor2FactorAuthApiModify()}
            >
              Confirm
            </ContainedButton>
          </Box>

          {/* <Typography variant="body2" mt={2}>
                                Input OTP from your Phone
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Two-Factor Authenticator Code"
                                type="password"
                                value={twoFactorOtpPhoneApiKey}
                                onChange={(e) => setTwoFactorOtpPhoneApiKey(e.target.value)}
                                sx={{ mt: 1 }}
                            /> */}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openAddressManagementConfModal}
        onClose={() => setOpenAddressManagementConfModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <Box
          sx={{
            textAlign: "center",
            p: 2,
          }}
        >
          {/* <FaExclamationCircle color="#dc3545" size={55} /> */}
        </Box>

        <DialogContent
          sx={{
            pt: 0,
          }}
        >
          <Typography variant="h6" align="center" sx={{ mb: 2 }}>
            {addrMgmtTitle}
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            {addrMgmtDescription}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            gap: 2,
            pb: 3,
          }}
        >
          <ContainedButton
            variant="contained"
            onClick={() => setOpenAddressManagementConfModal(false)}
            size="small"
            sx={{ width: 100 }}
          >
            Cancel
          </ContainedButton>
          <ContainedButton
            variant="contained"
            onClick={() => (
              setTwofaModalAddressWhiteListOpen(true),
              getCodeFromEmail("addresswhitelist")
            )}
            size="small"
            sx={{ width: 100 }}
          >
            {addrMgmtConfirmText}
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={twofaModalAddressWhiteListOpen}
        onClose={() => setTwofaModalAddressWhiteListOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Authentication</Typography>

          <IconButton onClick={() => setTwofaModalAddressWhiteListOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            To secure your account please complete the following verification.
          </Typography>

          <Typography variant="body2" mt={1}>
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              label="Email verification code"
              type="number"
              autoComplete="off"
              value={emailOtpAddr}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                setEmailOtpAddrOtp(value);
              }}
              onWheel={(e) => e.target.blur()}
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />

            <ContainedButton
              variant="contained"
              sx={{ whiteSpace: "nowrap" }}
              onClick={() => getCodeFromEmail("addresswhitelist")}
              disabled={isGetCodeButtonDisabled}
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          <Box>
            {isGetCodeButtonDisabled ? (
              <Typography sx={{ fontSize: "12px" }} mt={1}>
                Enter 8 digit code received by {localStorage.getItem("email")}
              </Typography>
            ) : (
              ""
            )}
          </Box>
          <Box>
            <Typography variant="body2" mt={2}>
              Input OTP from your Google Authenticator
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Two-Factor Authenticator Code"
              type="number"
              autoComplete="off"
              value={twoFactorAddrOtp}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                setTwoFactorAddrOtp(value);
              }}
              sx={{ mt: 1 }}
              helperText="Enter 6 digit code from Google Authenticator"
            />
          </Box>
          {/* <Typography variant="body2" color="error" mt={1}>
            {messageOtpSpecific}
          </Typography> */}
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            variant="contained"
            disabled={
              !(emailOtpAddr?.length === 8 && twoFactorAddrOtp?.length === 6)
            }
            onClick={
              emailOtpAddr?.length === 8 &&
              twoFactorAddrOtp?.length === 6 &&
              enableDisableAddressWhitelist()
            }
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={phoneAuthModalChangeOpen}
        onClose={() => setPhoneAuthModalChangeOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Authentication</Typography>
          <IconButton onClick={() => setPhoneAuthModalChangeOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {/* <Typography variant="body1" gutterBottom>
            Input OTP from your Google Authenticator
          </Typography> */}

          <TextField
            fullWidth
            type="number"
            variant="outlined"
            label="Enter Two-Factor Authenticator Code"
            value={twoFactorPhoneGaChange}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);
              setTwoFactorPhoneGaChange(value);
            }}
            onWheel={(e) => e.target.blur()}
            autoComplete="off"
            autoFocus
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            fullWidth
            variant="contained"
            sx={{ margin: "16px" }}
            onClick={
              twoFactorPhoneGaChange?.length === 6 &&
              changeStatusForPhoneAuth("off")
            }
            disabled={twoFactorPhoneGaChange == ""}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteAllApiModal}
        onClose={() => setDeleteAllApiModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            D
          </Typography>
          <Typography variant="h6">Delete All</Typography>
          <IconButton onClick={() => setDeleteAllApiModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            textAlign: "center",
          }}
        >
          <Typography variant="body1" mt={1}>
            Are you sure you want to delete all API keys?
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            pb: 2,
          }}
        >
          <OutlinedButton
            variant="outlined"
            onClick={() => setDeleteAllApiModal(false)}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton variant="contained" onClick={confirmDelete}>
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={socialAuthModalOpen}
        onClose={() => setSocialAuthModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Security Authentication</Typography>

          <IconButton onClick={() => setSocialAuthModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            To secure your account please complete the following verification.
          </Typography>

          <Typography variant="body2" mt={1}>
            Input OTP from your registered email address
          </Typography>
          <Box display="flex" gap={2} mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              label="Email verification code"
              type="number"
              autoComplete="off"
              value={emailOtpSocial}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                setEmailOtpSocial(value);
              }}
              onWheel={(e) => e.target.blur()}
              sx={{ flex: 1 }} // Makes the TextField take up remaining space
            />

            <ContainedButton
              variant="contained"
              sx={{ whiteSpace: "nowrap" }}
              onClick={() => getCodeFromEmail("addresswhitelist")}
              disabled={isGetCodeButtonDisabled}
            >
              {isGetCodeButtonDisabled ? `Resend in ${countdown}s` : "Get Code"}
            </ContainedButton>
          </Box>
          <Box>
            {isGetCodeButtonDisabled ? (
              <Typography sx={{ fontSize: "12px" }} mt={1}>
                Enter 8 digit code received by {localStorage.getItem("email")}
              </Typography>
            ) : (
              ""
            )}
          </Box>
          <Box>
            <Typography variant="body2" mt={2}>
              Input OTP from your Google Authenticator
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              label="Two-Factor Authenticator Code"
              type="number"
              autoComplete="off"
              value={twoFactorSocialOtp}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                setTwoFactorSocialOtp(value);
              }}
              sx={{ mt: 1 }}
              helperText="Enter 6 digit code from Google Authenticator"
            />
          </Box>
          {/* <Typography variant="body2" color="error" mt={1}>
            {messageOtpSpecific}
          </Typography> */}
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <ContainedButton
            variant="contained"
            disabled={
              !(
                emailOtpSocial?.length === 8 && twoFactorSocialOtp?.length === 6
              )
            }
            onClick={enableDisableSocialAuth}
          >
            Confirm
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title?.toUpperCase()}
        description={Infomodal[infoIndex]?.description}
      />

      {/* <Modal open={infoModal} onClose={handleCloseInfoModal}>
        <Box sx={contentStyle}>
          <div style={headerStyle}>
            <Typography variant="h6">
              {Infomodal[infoIndex]?.title?.toUpperCase()}
            </Typography>
            <i
              class="fa-solid fa-x"
              style={{ cursor: "pointer" }}
              onClick={handleCloseInfoModal}
            ></i>
          </div>
          <div style={bodyStyle}>
            <Typography variant="body1">
              {Infomodal[infoIndex]?.description}
            </Typography>
          </div>
        </Box>
      </Modal> */}
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const settingSection = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
  mb: 2,
};

const sectionHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: { xs: 2.5, md: 3 },
  py: 2,
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const sectionContent = {
  px: { xs: 2.5, md: 3 },
  py: { xs: 2, md: 2.5 },
};

const sectionTitle = {
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "0.01em",
};

const toggleRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  bgcolor: "var(--body-color-less2)",
  border: "1px solid rgba(125,125,125,0.15)",
  borderRadius: "12px",
  px: 2.5,
  py: 1.5,
  maxWidth: 480,
  mt: 1.5,
  cursor: "pointer",
};

export default Settings;
